import { config } from '@/config'
import { isMobile } from '@/utils'

const useMobileRouter = config.websiteModel === 'mobile' || (!config.noMobileModel && isMobile())
export const platform = useMobileRouter ? 'mobile' : 'desktop'

/**
 * 异步路由，登录后根据角色权限动态添加路由
 */
export const asyncRoutes = [
  {
    name: 'home',
    component: `/src/ui/views/${platform}/StatisticsAdminAcc/StatisticsAdminAccView.vue`,
    meta: {
      title: { zh: '首页', ko: '대시보드', en: 'Home', vi: 'Trang chủ', th: 'หน้าแรก', my: 'မူလစာမျက်နှာ' },
      icon: '<svg t="1719036283095" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7991" width="24" height="24"><path d="M526.130587 213.025725c-7.812854-8.171561-20.457517-8.163385-28.262196 0L190.812487 534.217325c-3.908982 4.088846-7.064782 11.970172-7.064782 17.619545L183.747705 959.616766l223.808383 0L407.556088 718.503601c0-56.47125 45.744798-102.250794 102.187433-102.250794l4.512958 0c56.436503 0 102.187433 45.773413 102.187433 102.250794L616.443912 959.616766l223.808383 0L840.252295 551.83687c0-5.641198-3.162954-13.537852-7.064782-17.619545L526.130587 213.025725z" p-id="7992"></path><path d="M951.023138 491.245094 543.783856 77.72487c-17.529613-17.800431-46.061605-17.775904-63.567713 0L72.976862 491.245094c-11.571609 11.750451-11.439776 30.669924 0.294323 42.256862 11.735122 11.58796 30.629046 11.455106 42.200655-0.295345L512 130.563066l396.52816 402.643545c11.571609 11.750451 30.465533 11.882283 42.200655 0.295345C962.463936 521.915018 962.595768 502.995545 951.023138 491.245094z" p-id="7993"></path></svg>',
      hidden: false,
      cache: true,
      public: {
        desktop: true,
        mobile: false,
      },
    },
  },
  {
    name: 'statistics',
    meta: {
      title: { zh: '统计', ko: '통계 보고서', en: 'Statistics', vi: 'Thống kê', th: 'สถิติ', my: 'စာရင်းအင်း' },
      icon: '<svg t="1719036243579" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4195" width="24" height="24"><path d="M112.270505 64.303538l31.978319 0 0 863.413582 767.479649 0 0 31.978319L112.270505 959.695438 112.270505 64.303538zM400.075373 448.043363l0 415.71712-191.869912 0 0-223.848231L400.075373 448.043363zM655.901922 480.021681l0 383.738801-191.869912 0L464.03201 448.043363l95.934956 127.912251L655.901922 480.021681zM911.728472 288.151769l0 575.608713-191.869912 0L719.85856 448.043363 911.728472 288.151769zM240.183779 512l-31.978319-31.978319 223.848231-223.848231 127.913275 127.913275 255.82655-223.848231-63.956637-63.956637 159.891593 0 0 159.891593-63.956637-63.956637-287.804868 255.82655-127.913275-127.913275L240.183779 512z" fill="#272636" p-id="4196"></path></svg>',
      hidden: false,
      cache: true,
      public: {
        desktop: true,
        mobile: false,
      },
    },
    children: [
      {
        name: 'admin_day',
        component: `/src/ui/views/${platform}/StatisticsAdminDay/StatisticsAdminDayView.vue`,
        meta: {
          title: {
            zh: '运营日统计',
            ko: '수익통계',
            en: 'Operational Day Statistics',
            vi: 'Thống kê ngày hoạt động',
            th: 'สถิติวันดำเนินการ',
            my: 'လည်ပတ်မှုနေ့ စာရင်းအင်း',
          },
          icon: '<svg t="1718878346333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9479" width="24" height="24"><path d="M183.515429 492.495238v67.657143l87.161904 0.024381 150.869334 55.734857h159.744a37.010286 37.010286 0 0 1 0 74.020571h-135.216762a12.361143 12.361143 0 0 0 0 24.697905h156.086857c10.630095 0 21.138286-2.267429 30.817524-6.704762l190.634666-87.064381a64.26819 64.26819 0 0 1 84.016762 29.354667 61.293714 61.293714 0 0 1-27.233524 82.578286L519.509333 913.310476a123.66019 123.66019 0 0 1-96.475428 6.022095l-197.388191-69.680761H183.515429v62.464H109.714286V492.495238h73.801143zM527.969524 97.52381C704.609524 97.52381 847.823238 241.200762 847.823238 418.425905c0 56.417524-14.506667 109.470476-40.009143 155.526095l-4.486095 1.926095-137.020952 62.585905-0.780191-4.071619a86.186667 86.186667 0 0 0-84.114286-67.852191l-151.161904-0.02438-150.796191-55.710477H232.71619v-67.705904h-23.649523a326.460952 326.460952 0 0 1-0.926477-24.673524C208.14019 241.176381 351.329524 97.52381 527.969524 97.52381z m60.025905 119.612952l-55.100953 55.369143-55.100952-55.369143-37.546667 37.741714 52.809143 53.101714h-71.582476v53.394286h84.845714v36.156953h-84.845714v53.394285h84.845714l0.024381 52.736h53.101714v-52.736h84.845715v-53.394285h-84.845715v-36.156953h84.845715v-53.394286H572.708571l52.809143-53.101714-37.546666-37.741714z" p-id="9480"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'usdt_day',
        component: `/src/ui/views/${platform}/StatisticsUsdtDay/StatisticsUsdtDayView.vue`,
        meta: {
          title: {
            zh: 'USDT日统计',
            ko: 'USDT일일통계',
            en: 'USDT Day Statistics',
            vi: 'Thống kê ngày USDT',
            th: 'สถิติวัน USDT',
            my: 'USDT နေ့စဉ် စာရင်းအင်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'bank_day',
        component: `/src/ui/views/${platform}/StatisticsBankDay/StatisticsBankDayView.vue`,
        meta: {
          title: {
            zh: '银行日统计',
            ko: '원화일일통계',
            en: 'Bank Day Statistics',
            vi: 'Thống kê ngày ngân hàng',
            th: 'สถิติวันธนาคาร',
            my: 'ဘဏ်နေ့ စာရင်းအင်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'promotion_day',
        component: `/src/ui/views/${platform}/StatisticsPromotionDay/StatisticsPromotionDayView.vue`,
        meta: {
          title: {
            zh: '推广日统计',
            ko: '이벤트 통계',
            en: 'Promotion Day Statistics',
            vi: 'Thống kê ngày khuyến mãi',
            th: 'สถิติวันส่งเสริมการขาย',
            my: 'ဖြန့်ချိရေးနေ့ စာရင်းအင်း',
          },
          icon: '<svg t="1718878346333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9479" width="24" height="24"><path d="M183.515429 492.495238v67.657143l87.161904 0.024381 150.869334 55.734857h159.744a37.010286 37.010286 0 0 1 0 74.020571h-135.216762a12.361143 12.361143 0 0 0 0 24.697905h156.086857c10.630095 0 21.138286-2.267429 30.817524-6.704762l190.634666-87.064381a64.26819 64.26819 0 0 1 84.016762 29.354667 61.293714 61.293714 0 0 1-27.233524 82.578286L519.509333 913.310476a123.66019 123.66019 0 0 1-96.475428 6.022095l-197.388191-69.680761H183.515429v62.464H109.714286V492.495238h73.801143zM527.969524 97.52381C704.609524 97.52381 847.823238 241.200762 847.823238 418.425905c0 56.417524-14.506667 109.470476-40.009143 155.526095l-4.486095 1.926095-137.020952 62.585905-0.780191-4.071619a86.186667 86.186667 0 0 0-84.114286-67.852191l-151.161904-0.02438-150.796191-55.710477H232.71619v-67.705904h-23.649523a326.460952 326.460952 0 0 1-0.926477-24.673524C208.14019 241.176381 351.329524 97.52381 527.969524 97.52381z m60.025905 119.612952l-55.100953 55.369143-55.100952-55.369143-37.546667 37.741714 52.809143 53.101714h-71.582476v53.394286h84.845714v36.156953h-84.845714v53.394285h84.845714l0.024381 52.736h53.101714v-52.736h84.845715v-53.394285h-84.845715v-36.156953h84.845715v-53.394286H572.708571l52.809143-53.101714-37.546666-37.741714z" p-id="9480"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'provider_day',
        component: `/src/ui/views/${platform}/StatisticsProviderDay/StatisticsProviderDayView.vue`,
        meta: {
          title: {
            zh: '游戏社日统计',
            ko: '게임사 통계',
            en: 'Game Community Day Statistics',
            vi: 'Thống kê ngày cộng đồng trò chơi',
            th: 'สถิติวันชุมชนเกม',
            my: 'ဂိမ်းအသိုင်းအဝိုင်းနေ့ စာရင်းအင်း',
          },
          icon: '<svg t="1718878346333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9479" width="24" height="24"><path d="M183.515429 492.495238v67.657143l87.161904 0.024381 150.869334 55.734857h159.744a37.010286 37.010286 0 0 1 0 74.020571h-135.216762a12.361143 12.361143 0 0 0 0 24.697905h156.086857c10.630095 0 21.138286-2.267429 30.817524-6.704762l190.634666-87.064381a64.26819 64.26819 0 0 1 84.016762 29.354667 61.293714 61.293714 0 0 1-27.233524 82.578286L519.509333 913.310476a123.66019 123.66019 0 0 1-96.475428 6.022095l-197.388191-69.680761H183.515429v62.464H109.714286V492.495238h73.801143zM527.969524 97.52381C704.609524 97.52381 847.823238 241.200762 847.823238 418.425905c0 56.417524-14.506667 109.470476-40.009143 155.526095l-4.486095 1.926095-137.020952 62.585905-0.780191-4.071619a86.186667 86.186667 0 0 0-84.114286-67.852191l-151.161904-0.02438-150.796191-55.710477H232.71619v-67.705904h-23.649523a326.460952 326.460952 0 0 1-0.926477-24.673524C208.14019 241.176381 351.329524 97.52381 527.969524 97.52381z m60.025905 119.612952l-55.100953 55.369143-55.100952-55.369143-37.546667 37.741714 52.809143 53.101714h-71.582476v53.394286h84.845714v36.156953h-84.845714v53.394285h84.845714l0.024381 52.736h53.101714v-52.736h84.845715v-53.394285h-84.845715v-36.156953h84.845715v-53.394286H572.708571l52.809143-53.101714-37.546666-37.741714z" p-id="9480"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'agent_day',
        component: `/src/ui/views/${platform}/StatisticsAgentDay/StatisticsAgentDayView.vue`,
        meta: {
          title: {
            zh: '代理商日统计',
            ko: '파트너 통계',
            en: 'Agent Day Statistics',
            vi: 'Thống kê ngày đại lý',
            th: 'สถิติวันตัวแทน',
            my: 'ကိုယ်စားလှယ်နေ့ စာရင်းအင်း',
          },
          icon: '<svg t="1718878346333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9479" width="24" height="24"><path d="M183.515429 492.495238v67.657143l87.161904 0.024381 150.869334 55.734857h159.744a37.010286 37.010286 0 0 1 0 74.020571h-135.216762a12.361143 12.361143 0 0 0 0 24.697905h156.086857c10.630095 0 21.138286-2.267429 30.817524-6.704762l190.634666-87.064381a64.26819 64.26819 0 0 1 84.016762 29.354667 61.293714 61.293714 0 0 1-27.233524 82.578286L519.509333 913.310476a123.66019 123.66019 0 0 1-96.475428 6.022095l-197.388191-69.680761H183.515429v62.464H109.714286V492.495238h73.801143zM527.969524 97.52381C704.609524 97.52381 847.823238 241.200762 847.823238 418.425905c0 56.417524-14.506667 109.470476-40.009143 155.526095l-4.486095 1.926095-137.020952 62.585905-0.780191-4.071619a86.186667 86.186667 0 0 0-84.114286-67.852191l-151.161904-0.02438-150.796191-55.710477H232.71619v-67.705904h-23.649523a326.460952 326.460952 0 0 1-0.926477-24.673524C208.14019 241.176381 351.329524 97.52381 527.969524 97.52381z m60.025905 119.612952l-55.100953 55.369143-55.100952-55.369143-37.546667 37.741714 52.809143 53.101714h-71.582476v53.394286h84.845714v36.156953h-84.845714v53.394285h84.845714l0.024381 52.736h53.101714v-52.736h84.845715v-53.394285h-84.845715v-36.156953h84.845715v-53.394286H572.708571l52.809143-53.101714-37.546666-37.741714z" p-id="9480"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'agent_acc',
        component: `/src/ui/views/${platform}/StatisticsAgentAcc/StatisticsAgentAccView.vue`,
        meta: {
          title: {
            zh: '代理商总统计',
            ko: '파트너 누적통계',
            en: 'Total Agent Statistics',
            vi: 'Thống Kê Đại Lý Tổng',
            th: 'สถิติตัวแทนรวม',
            my: 'ကိုယ်စားလှယ်စုစုပေါင်း စာရင်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'stat_all',
        component: `/src/ui/views/${platform}/StatisticsAll/StatisticsAllView.vue`,
        meta: {
          title: {
            zh: '运营总统计',
            ko: '운영 누적통계',
            en: 'Cumulative Statistics',
            vi: 'Thống kê tích lũy',
            th: 'สถิติสะสม',
            my: 'စုစုပေါင်းစာရင်းအင်း',
          },
          icon: '<svg t="1718878346333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9479" width="24" height="24"><path d="M183.515429 492.495238v67.657143l87.161904 0.024381 150.869334 55.734857h159.744a37.010286 37.010286 0 0 1 0 74.020571h-135.216762a12.361143 12.361143 0 0 0 0 24.697905h156.086857c10.630095 0 21.138286-2.267429 30.817524-6.704762l190.634666-87.064381a64.26819 64.26819 0 0 1 84.016762 29.354667 61.293714 61.293714 0 0 1-27.233524 82.578286L519.509333 913.310476a123.66019 123.66019 0 0 1-96.475428 6.022095l-197.388191-69.680761H183.515429v62.464H109.714286V492.495238h73.801143zM527.969524 97.52381C704.609524 97.52381 847.823238 241.200762 847.823238 418.425905c0 56.417524-14.506667 109.470476-40.009143 155.526095l-4.486095 1.926095-137.020952 62.585905-0.780191-4.071619a86.186667 86.186667 0 0 0-84.114286-67.852191l-151.161904-0.02438-150.796191-55.710477H232.71619v-67.705904h-23.649523a326.460952 326.460952 0 0 1-0.926477-24.673524C208.14019 241.176381 351.329524 97.52381 527.969524 97.52381z m60.025905 119.612952l-55.100953 55.369143-55.100952-55.369143-37.546667 37.741714 52.809143 53.101714h-71.582476v53.394286h84.845714v36.156953h-84.845714v53.394285h84.845714l0.024381 52.736h53.101714v-52.736h84.845715v-53.394285h-84.845715v-36.156953h84.845715v-53.394286H572.708571l52.809143-53.101714-37.546666-37.741714z" p-id="9480"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'ggr',
        component: `/src/ui/views/${platform}/StatisticsGGR/index.vue`,
        meta: {
          title: {
            zh: 'GGR 统计',
            ko: 'GGR 통계',
            en: 'GGR Statistics',
            vi: 'Thống kê GGR',
            th: 'สถิติ GGR',
            my: 'စာရင်း GGR',
          },
          icon: '<svg t="1718878346333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9479" width="24" height="24"><path d="M183.515429 492.495238v67.657143l87.161904 0.024381 150.869334 55.734857h159.744a37.010286 37.010286 0 0 1 0 74.020571h-135.216762a12.361143 12.361143 0 0 0 0 24.697905h156.086857c10.630095 0 21.138286-2.267429 30.817524-6.704762l190.634666-87.064381a64.26819 64.26819 0 0 1 84.016762 29.354667 61.293714 61.293714 0 0 1-27.233524 82.578286L519.509333 913.310476a123.66019 123.66019 0 0 1-96.475428 6.022095l-197.388191-69.680761H183.515429v62.464H109.714286V492.495238h73.801143zM527.969524 97.52381C704.609524 97.52381 847.823238 241.200762 847.823238 418.425905c0 56.417524-14.506667 109.470476-40.009143 155.526095l-4.486095 1.926095-137.020952 62.585905-0.780191-4.071619a86.186667 86.186667 0 0 0-84.114286-67.852191l-151.161904-0.02438-150.796191-55.710477H232.71619v-67.705904h-23.649523a326.460952 326.460952 0 0 1-0.926477-24.673524C208.14019 241.176381 351.329524 97.52381 527.969524 97.52381z m60.025905 119.612952l-55.100953 55.369143-55.100952-55.369143-37.546667 37.741714 52.809143 53.101714h-71.582476v53.394286h84.845714v36.156953h-84.845714v53.394285h84.845714l0.024381 52.736h53.101714v-52.736h84.845715v-53.394285h-84.845715v-36.156953h84.845715v-53.394286H572.708571l52.809143-53.101714-37.546666-37.741714z" p-id="9480"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'stat_sports',
        component: `/src/ui/views/${platform}/StatisticsSports/StatisticsSportView.vue`,
        meta: {
          title: {
            zh: '体育统计',
            ko: '스포츠통계',
            en: 'Sports Statistics',
            vi: 'Thống kê thể thao',
            th: 'สถิติกีฬา',
            my: 'စုရင်းအင်းချုပ်ချုပ်',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
    ],
  },
  {
    name: 'transactions',
    meta: {
      title: { zh: '交易', ko: '입출금 관리', en: 'Transaction', vi: 'Giao dịch', th: 'ธุรกรรม', my: 'ငွေလွှဲ' },
      icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
      hidden: false,
      cache: true,
      needLogin: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'player_deposit',
        path: 'deposit/player',
        component: `/src/ui/views/${platform}/PlayerDeposit/PlayerDepositView.vue`,
        meta: {
          title: {
            zh: '玩家充值',
            ko: '회원입금',
            en: 'Player Recharge',
            vi: 'Nạp tiền người chơi',
            th: 'เติมเงินผู้เล่น',
            my: 'ကစားသမားငွေဖြည့်',
          },
          icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'player_withdraw',
        path: 'withdraw/player',
        component: `/src/ui/views/${platform}/PlayerWithdraw/PlayerWithdrawView.vue`,
        meta: {
          title: {
            zh: '玩家提现',
            ko: '회원출금',
            en: 'Player Withdrawal',
            vi: 'Rút tiền người chơi',
            th: 'ถอนเงินผู้เล่น',
            my: 'ကစားသမားငွေထုတ်',
          },
          icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'agent_withdraw',
        path: 'withdraw/agent',
        component: `/src/ui/views/${platform}/AgentWithdrawList/AgentWithdrawListView.vue`,
        meta: {
          title: {
            zh: '代理商提款',
            ko: '파트너 출금',
            en: 'Agent Withdrawal',
            vi: 'Rút tiền đại lý',
            th: 'ถอนเงินตัวแทน',
            my: 'ကိုယ်စားလှယ်ငွေထုတ်',
          },
          icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'finance_maintenance',
        path: 'finance/maintenance',
        component: `/src/ui/views/${platform}/FinanceMaintenance/FinanceMaintenanceView.vue`,
        meta: {
          title: {
            zh: '财务维护',
            ko: '입출금 점검',
            en: 'Financial Maintenance',
            vi: 'Bảo trì tài chính',
            th: 'บำรุงรักษาทางการเงิน',
            my: 'ဘဏ္ဍာရေး ပြုပြင်ထိန်းသိမ်းမှု',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },
  {
    name: 'usdt',
    meta: {
      title: {
        zh: '虚拟币交易',
        ko: '가상화폐 거래',
        en: 'USDT Transaction',
        vi: 'USDT Transaction',
        th: 'USDT Transaction',
        my: 'USDT Transaction',
      },
      icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
      hidden: false,
      cache: true,
      needLogin: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'usdt_deposit',
        path: 'deposit/usdt',
        component: `/src/ui/views/${platform}/PlayerDepositUsdt/PlayerDepositUsdtView.vue`,
        meta: {
          title: {
            zh: 'USDT充值',
            ko: 'USDT 입금',
            en: 'USDT Recharge',
            vi: 'USDT Recharge',
            th: 'USDT Recharge',
            my: 'USDT Recharge',
          },
          icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },

      {
        name: 'usdt_withdraw',
        path: 'withdraw/usdt',
        component: `/src/ui/views/${platform}/PlayerWithdraw/PlayerWithdrawView.vue`,
        meta: {
          title: {
            zh: 'USDT提现',
            ko: 'USDT 출금',
            en: 'USDT Withdrawal',
            vi: 'USDT Withdrawal',
            th: 'USDT Withdrawal',
            my: 'USDT Withdrawal',
          },
          icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },
  {
    name: 'events',
    meta: {
      title: { zh: '活动', ko: '이벤트 관리', en: 'Event', vi: 'Sự kiện', th: 'กิจกรรม', my: 'ပွဲအစီအစဉ်' },
      icon: '<svg t="1717141227477" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6869" width="24" height="24"><path d="M963.29 341.59v122.261H547.201V254.535c-10.345-1.035-20.345-2.206-28.88-3.649v-0.38h-1.815l0.018 0.01h1.783v0.397h-1.436l-0.01-0.01c-0.046 0.044-0.365 0.343-0.688 0.343-11.052 1.486-24.608 3.289-39.929 4.776v207.856H60.142V274.116c0-13.613 11.025-24.642 24.627-24.642h57.918c1.266 0 2.508 0.091 3.727 0.281h149.013c-50.925-11.046-89.136-33.621-90.531-75.309-1.441-49.108 52.048-128.487 130.127-110.373 80.61 18.773 136.931 83.409 180.069 138.791C558.605 146.406 620.274 73.66 704.399 62.193c70.296-9.227 128.395 63.519 120.899 111.51-6.384 42.057-45.287 64.972-94.855 76.032h147.254a24.824 24.824 0 0 1 3.611-0.261h57.914c13.602 0 24.627 11.029 24.627 24.642v62.242a24.73 24.73 0 0 1-0.559 5.232zM343.614 107.601c-38.903-15.881-61.692 1.154-78.088 29.211-8.923 15.84-18.516 36.908-4.291 52.398 37.425 39.888 140.094 36.948 208.954 29.528-32.474-42.02-72.393-88.96-126.575-111.137z m425.354 81.283c26.738-35.471-25.671-109.304-82-82.013-53.868 26.244-92.716 69.025-126.225 111.144 28.84 2.607 58.099 3.289 86.994 1.833 35.309-1.48 100.558-4.043 121.231-30.964zM479.08 962.949H123.238c-13.602 0-24.627-11.029-24.627-24.642v-440.81H479.08v465.452z m445.704-43.177c0 3.452-0.397 6.799-1.118 10.011v8.524c0 13.613-11.024 24.642-24.626 24.642h-57.914c-0.069 0-0.139-0.003-0.203-0.003H544.352V497.497h380.432v422.275z" fill="" p-id="6870"></path></svg>',
      hidden: false,
      cache: true,
      public: {
        desktop: true,
        mobile: false,
      },
    },
    children: [
      {
        name: 'coupons_send2',
        component: `/src/ui/views/${platform}/AdminSendCoupons/AdminSendCouponsView.vue`,
        meta: {
          title: {
            zh: '发送代金券',
            ko: '쿠폰발송',
            en: 'Send Voucher',
            vi: 'Gửi phiếu giảm giá',
            th: 'ส่งบัตรกำนัล',
            my: 'ဗောက်ချာပေးပို့',
          },
          icon: '<svg t="1719054122032" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16974" width="24" height="24"><path d="M868.949333 580.096a301.952 301.952 0 0 0-23.850666-111.061333c-9.685333-23.082667-24.106667-43.818667-35.584-66.133334a225.066667 225.066667 0 0 1-18.176-158.805333c-59.818667 22.229333-108.288 67.413333-131.456 122.325333a199.253333 199.253333 0 0 0-14.805334 58.666667 490.325333 490.325333 0 0 1-102.528-267.52 475.733333 475.733333 0 0 1 3.072-92.16 533.76 533.76 0 0 0-136.533333 152.746667 476.714667 476.714667 0 0 0-59.733333 328.234666A313.6 313.6 0 0 1 262.314667 349.866667c-65.962667 57.344-106.112 137.386667-110.848 220.330666-4.821333 84.821333 28.202667 169.898667 90.026666 233.386667 60.757333 62.421333 147.712 102.186667 238.933334 108.928 93.44 6.912 188.501333-20.608 260.266666-75.52 68.949333-52.565333 114.602667-129.024 125.525334-210.389333 0.469333-3.797333 1.408-19.285333 2.730666-46.506667z" fill="#FF5000" p-id="16975"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'event_mgr',
        component: `/src/ui/views/${platform}/EventManager/EventManagerView.vue`,
        meta: {
          title: {
            zh: '活动管理',
            ko: '이벤트 생성',
            en: 'Event Management',
            vi: 'Quản lý sự kiện',
            th: 'การจัดการกิจกรรม',
            my: 'ပွဲစီမံခန့်ခွဲမှု',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'promotion',
        component: `/src/ui/views/${platform}/Promotion/PromotionView.vue`,
        meta: {
          title: {
            zh: '推广页',
            ko: '이벤트 페이지',
            en: 'Promotion Page',
            vi: 'Trang khuyến mãi',
            th: 'หน้าโปรโมชั่น',
            my: 'ဖြန့်ချိရေး စာမျက်နှာ',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'player_rebate',
        component: `/src/ui/views/${platform}/PlayerRebate/PlayerRebateView.vue`,
        meta: {
          title: {
            zh: '下注回扣',
            ko: '리베이트 설정',
            en: 'Bet Rebate',
            vi: 'Hoàn tiền cược',
            th: 'เงินคืนเดิมพัน',
            my: 'ပွဲစဉ်ပြန်အမ်းငွေ',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'player_lossback',
        component: `/src/ui/views/${platform}/PlayerLossback/PlayerLossbackView.vue`,
        meta: {
          title: {
            zh: '落选返现',
            ko: '낙첨이벤트 설정',
            en: 'Lossback',
            vi: 'Hoàn tiền thua',
            th: 'เงินคืนที่สูญเสีย',
            my: 'ပြန်အမ်းငွေဗဵ่สูญเสีย',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'player_cashback',
        component: `/src/ui/views/${platform}/PlayerCashbackConfig/PlayerCashbackView.vue`,
        meta: {
          title: {
            zh: '输钱返现',
            ko: '캐시백 설정',
            en: 'Cashback',
            vi: 'Hoàn tiền',
            th: 'เงินคืน',
            my: 'ပြန်အမ်းငွေ',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
    ],
  },

  {
    name: 'user_mgr',
    meta: {
      title: {
        zh: '用户管理',
        ko: '고객관리',
        en: 'User Management',
        vi: 'Quản lý người dùng',
        th: 'การจัดการผู้ใช้',
        my: 'အသုံးပြုသူစီမံခန့်ခွဲမှု',
      },
      icon: '<svg t="1706775114716" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12083" width="32" height="32"><path d="M379.392 481.792c14.848 71.68 69.12 124.928 134.144 124.928 64.512 0 118.784-53.248 134.144-124.928 13.312-2.048 24.064-15.36 24.064-32.256 0-15.36-9.216-28.16-21.504-31.744-9.728-79.36-67.072-140.288-136.704-140.288s-126.976 61.44-136.704 141.312c-11.264 4.096-19.456 16.384-19.456 30.72 0 15.872 9.728 29.184 22.016 32.256z m237.056 147.968l-86.528 125.952v-57.344h-35.84v56.832L430.592 629.76s-83.968-15.36-208.384 99.328v132.096h575.488v-124.416s-50.688-103.424-181.248-107.008z" fill="" p-id="12084"></path><path d="M466.944 653.824l20.48 31.744h47.104l20.48-31.744-18.944-31.744h-48.64l-20.48 31.744zM209.92 345.6c13.312 64.512 60.928 112.64 118.784 115.712-2.56-33.792-6.144-152.576 126.976-201.728C438.784 199.68 390.656 156.16 334.336 156.16c-64.512 0-118.272 56.832-126.976 131.072-10.24 3.584-17.92 15.36-17.92 28.672 0 14.848 8.704 27.136 20.48 29.696z m164.864 218.112l-25.088 36.864v-53.248h-33.28v52.736L257.536 482.816s-78.336-14.336-193.536 92.16v122.368s143.872-0.512 151.552 0c57.344-83.968 188.928-107.52 188.928-107.52s-17.408-12.8-29.696-26.112z" fill="" p-id="12085"></path><path d="M291.328 505.344l18.944 29.696h44.032c-18.944-29.696-23.04-59.392-23.04-59.392h-20.992l-18.944 29.696zM813.568 345.6c-13.312 64.512-60.928 112.64-118.784 115.712 2.56-33.792 6.144-152.576-127.488-201.728 17.408-60.416 65.024-103.936 121.344-103.936 64.512 0 118.272 56.832 126.976 131.072 10.24 3.584 17.92 15.36 17.92 28.672 0.512 15.36-8.192 27.648-19.968 30.208z m-164.864 218.112l25.088 36.864v-53.248h33.28v52.736l59.392-116.736s78.336-14.336 193.536 92.16v122.368s-143.872-0.512-151.552 0c-57.344-84.48-188.928-108.032-188.928-108.032s16.896-12.8 29.184-26.112z" fill="" p-id="12086"></path><path d="M732.16 505.344l-18.944 29.696h-44.032c18.944-29.696 23.04-59.392 23.04-59.392h20.992l18.944 29.696z" fill="" p-id="12087"></path></svg>',
      hidden: false,
      cache: true,
      public: {
        desktop: true,
        mobile: false,
      },
    },
    children: [
      {
        name: 'userCenter',
        component: `/src/ui/views/${platform}/UserCenter/index.vue`,
        meta: {
          title: { zh: '用户中心', ko: '회원정보조회', en: 'UserCenter', vi: 'UserCenter', th: 'UserCenter', my: 'UserCenter' },
          icon: '<svg t="1719036283095" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7991" width="24" height="24"><path d="M526.130587 213.025725c-7.812854-8.171561-20.457517-8.163385-28.262196 0L190.812487 534.217325c-3.908982 4.088846-7.064782 11.970172-7.064782 17.619545L183.747705 959.616766l223.808383 0L407.556088 718.503601c0-56.47125 45.744798-102.250794 102.187433-102.250794l4.512958 0c56.436503 0 102.187433 45.773413 102.187433 102.250794L616.443912 959.616766l223.808383 0L840.252295 551.83687c0-5.641198-3.162954-13.537852-7.064782-17.619545L526.130587 213.025725z" p-id="7992"></path><path d="M951.023138 491.245094 543.783856 77.72487c-17.529613-17.800431-46.061605-17.775904-63.567713 0L72.976862 491.245094c-11.571609 11.750451-11.439776 30.669924 0.294323 42.256862 11.735122 11.58796 30.629046 11.455106 42.200655-0.295345L512 130.563066l396.52816 402.643545c11.571609 11.750451 30.465533 11.882283 42.200655 0.295345C962.463936 521.915018 962.595768 502.995545 951.023138 491.245094z" p-id="7993"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'player_registers',
        component: `/src/ui/views/${platform}/PlayerRegisterApply/PlayerRegisterApplyView.vue`,
        meta: {
          title: {
            zh: '注册申请',
            ko: '회원 가입심사',
            en: 'Registration Application',
            vi: 'Đơn Đăng Ký',
            th: 'คำขอลงทะเบียน',
            my: 'မှတ်ပုံတင် လျှောက်လွှာ',
          },
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'player_registers_limit',
        component: `/src/ui/views/${platform}/PlayerRegisterLimit/PlayerRegisterLimitView.vue`,
        meta: {
          title: {
            zh: '限制注册',
            ko: '회원가입 제한',
            en: 'Limit Registration',
            vi: 'Giới hạn đăng ký',
            th: 'จำกัดการลงทะเบียน',
            my: 'မှတ်ပုံတင်ကို ကန့်သတ်ပါ',
          },
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'players',
        component: `/src/ui/views/${platform}/PlayerList/PlayerListView.vue`,
        meta: {
          title: {
            zh: '玩家管理',
            ko: '회원 리스트',
            en: 'Player Management',
            vi: 'Quản lý người chơi',
            th: 'การจัดการผู้เล่น',
            my: 'ကစားသမားစီမံခန့်ခွဲမှု',
          },
          icon: '<svg t="1706775114716" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12083" width="32" height="32"><path d="M379.392 481.792c14.848 71.68 69.12 124.928 134.144 124.928 64.512 0 118.784-53.248 134.144-124.928 13.312-2.048 24.064-15.36 24.064-32.256 0-15.36-9.216-28.16-21.504-31.744-9.728-79.36-67.072-140.288-136.704-140.288s-126.976 61.44-136.704 141.312c-11.264 4.096-19.456 16.384-19.456 30.72 0 15.872 9.728 29.184 22.016 32.256z m237.056 147.968l-86.528 125.952v-57.344h-35.84v56.832L430.592 629.76s-83.968-15.36-208.384 99.328v132.096h575.488v-124.416s-50.688-103.424-181.248-107.008z" fill="" p-id="12084"></path><path d="M466.944 653.824l20.48 31.744h47.104l20.48-31.744-18.944-31.744h-48.64l-20.48 31.744zM209.92 345.6c13.312 64.512 60.928 112.64 118.784 115.712-2.56-33.792-6.144-152.576 126.976-201.728C438.784 199.68 390.656 156.16 334.336 156.16c-64.512 0-118.272 56.832-126.976 131.072-10.24 3.584-17.92 15.36-17.92 28.672 0 14.848 8.704 27.136 20.48 29.696z m164.864 218.112l-25.088 36.864v-53.248h-33.28v52.736L257.536 482.816s-78.336-14.336-193.536 92.16v122.368s143.872-0.512 151.552 0c57.344-83.968 188.928-107.52 188.928-107.52s-17.408-12.8-29.696-26.112z" fill="" p-id="12085"></path><path d="M291.328 505.344l18.944 29.696h44.032c-18.944-29.696-23.04-59.392-23.04-59.392h-20.992l-18.944 29.696zM813.568 345.6c-13.312 64.512-60.928 112.64-118.784 115.712 2.56-33.792 6.144-152.576-127.488-201.728 17.408-60.416 65.024-103.936 121.344-103.936 64.512 0 118.272 56.832 126.976 131.072 10.24 3.584 17.92 15.36 17.92 28.672 0.512 15.36-8.192 27.648-19.968 30.208z m-164.864 218.112l25.088 36.864v-53.248h33.28v52.736l59.392-116.736s78.336-14.336 193.536 92.16v122.368s-143.872-0.512-151.552 0c-57.344-84.48-188.928-108.032-188.928-108.032s16.896-12.8 29.184-26.112z" fill="" p-id="12086"></path><path d="M732.16 505.344l-18.944 29.696h-44.032c18.944-29.696 23.04-59.392 23.04-59.392h20.992l18.944 29.696z" fill="" p-id="12087"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },

      {
        name: 'bi_push',
        component: `/src/ui/views/${platform}/BiPush/BiPushView.vue`,
        meta: {
          title: {
            zh: '风险用户(Vera)',
            ko: '양방회원(Vera)',
            en: 'Risk User(Vera)',
            vi: 'Người chơi nguy hiểm(Vera)',
            th: 'ผู้เล่นที่มีความเสี่ยง(Vera)',
            my: 'ကစားသမားအမှားအယှက်(Vera)',
          },
          icon: '<svg t="1706775114716" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12083" width="32" height="32"><path d="M379.392 481.792c14.848 71.68 69.12 124.928 134.144 124.928 64.512 0 118.784-53.248 134.144-124.928 13.312-2.048 24.064-15.36 24.064-32.256 0-15.36-9.216-28.16-21.504-31.744-9.728-79.36-67.072-140.288-136.704-140.288s-126.976 61.44-136.704 141.312c-11.264 4.096-19.456 16.384-19.456 30.72 0 15.872 9.728 29.184 22.016 32.256z m237.056 147.968l-86.528 125.952v-57.344h-35.84v56.832L430.592 629.76s-83.968-15.36-208.384 99.328v132.096h575.488v-124.416s-50.688-103.424-181.248-107.008z" fill="" p-id="12084"></path><path d="M466.944 653.824l20.48 31.744h47.104l20.48-31.744-18.944-31.744h-48.64l-20.48 31.744zM209.92 345.6c13.312 64.512 60.928 112.64 118.784 115.712-2.56-33.792-6.144-152.576 126.976-201.728C438.784 199.68 390.656 156.16 334.336 156.16c-64.512 0-118.272 56.832-126.976 131.072-10.24 3.584-17.92 15.36-17.92 28.672 0 14.848 8.704 27.136 20.48 29.696z m164.864 218.112l-25.088 36.864v-53.248h-33.28v52.736L257.536 482.816s-78.336-14.336-193.536 92.16v122.368s143.872-0.512 151.552 0c57.344-83.968 188.928-107.52 188.928-107.52s-17.408-12.8-29.696-26.112z" fill="" p-id="12085"></path><path d="M291.328 505.344l18.944 29.696h44.032c-18.944-29.696-23.04-59.392-23.04-59.392h-20.992l-18.944 29.696zM813.568 345.6c-13.312 64.512-60.928 112.64-118.784 115.712 2.56-33.792 6.144-152.576-127.488-201.728 17.408-60.416 65.024-103.936 121.344-103.936 64.512 0 118.272 56.832 126.976 131.072 10.24 3.584 17.92 15.36 17.92 28.672 0.512 15.36-8.192 27.648-19.968 30.208z m-164.864 218.112l25.088 36.864v-53.248h33.28v52.736l59.392-116.736s78.336-14.336 193.536 92.16v122.368s-143.872-0.512-151.552 0c-57.344-84.48-188.928-108.032-188.928-108.032s16.896-12.8 29.184-26.112z" fill="" p-id="12086"></path><path d="M732.16 505.344l-18.944 29.696h-44.032c18.944-29.696 23.04-59.392 23.04-59.392h20.992l18.944 29.696z" fill="" p-id="12087"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },

      {
        name: 'agent_list',
        component: `/src/ui/views/${platform}/AgentList/AgentListView.vue`,
        meta: {
          title: {
            zh: '代理商列表',
            ko: '파트너 리스트',
            en: 'Agent List',
            vi: 'Danh sách đại lý',
            th: 'รายชื่อตัวแทน',
            my: 'ကိုယ်စားလှယ်စာရင်း',
          },
          icon: '<svg t="1706775114716" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12083" width="32" height="32"><path d="M379.392 481.792c14.848 71.68 69.12 124.928 134.144 124.928 64.512 0 118.784-53.248 134.144-124.928 13.312-2.048 24.064-15.36 24.064-32.256 0-15.36-9.216-28.16-21.504-31.744-9.728-79.36-67.072-140.288-136.704-140.288s-126.976 61.44-136.704 141.312c-11.264 4.096-19.456 16.384-19.456 30.72 0 15.872 9.728 29.184 22.016 32.256z m237.056 147.968l-86.528 125.952v-57.344h-35.84v56.832L430.592 629.76s-83.968-15.36-208.384 99.328v132.096h575.488v-124.416s-50.688-103.424-181.248-107.008z" fill="" p-id="12084"></path><path d="M466.944 653.824l20.48 31.744h47.104l20.48-31.744-18.944-31.744h-48.64l-20.48 31.744zM209.92 345.6c13.312 64.512 60.928 112.64 118.784 115.712-2.56-33.792-6.144-152.576 126.976-201.728C438.784 199.68 390.656 156.16 334.336 156.16c-64.512 0-118.272 56.832-126.976 131.072-10.24 3.584-17.92 15.36-17.92 28.672 0 14.848 8.704 27.136 20.48 29.696z m164.864 218.112l-25.088 36.864v-53.248h-33.28v52.736L257.536 482.816s-78.336-14.336-193.536 92.16v122.368s143.872-0.512 151.552 0c57.344-83.968 188.928-107.52 188.928-107.52s-17.408-12.8-29.696-26.112z" fill="" p-id="12085"></path><path d="M291.328 505.344l18.944 29.696h44.032c-18.944-29.696-23.04-59.392-23.04-59.392h-20.992l-18.944 29.696zM813.568 345.6c-13.312 64.512-60.928 112.64-118.784 115.712 2.56-33.792 6.144-152.576-127.488-201.728 17.408-60.416 65.024-103.936 121.344-103.936 64.512 0 118.272 56.832 126.976 131.072 10.24 3.584 17.92 15.36 17.92 28.672 0.512 15.36-8.192 27.648-19.968 30.208z m-164.864 218.112l25.088 36.864v-53.248h33.28v52.736l59.392-116.736s78.336-14.336 193.536 92.16v122.368s-143.872-0.512-151.552 0c-57.344-84.48-188.928-108.032-188.928-108.032s16.896-12.8 29.184-26.112z" fill="" p-id="12086"></path><path d="M732.16 505.344l-18.944 29.696h-44.032c18.944-29.696 23.04-59.392 23.04-59.392h20.992l18.944 29.696z" fill="" p-id="12087"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
    ],
  },

  {
    name: 'csr_player',
    meta: {
      title: {
        zh: '玩家CSR',
        ko: '회원CSR',
        en: 'Player CSR',
        vi: 'CSR người chơi',
        th: 'CSR ผู้เล่น',
        my: 'ကစားသမား CSR',
      },
      icon: '<svg t="1706775114716" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12083" width="32" height="32"><path d="M379.392 481.792c14.848 71.68 69.12 124.928 134.144 124.928 64.512 0 118.784-53.248 134.144-124.928 13.312-2.048 24.064-15.36 24.064-32.256 0-15.36-9.216-28.16-21.504-31.744-9.728-79.36-67.072-140.288-136.704-140.288s-126.976 61.44-136.704 141.312c-11.264 4.096-19.456 16.384-19.456 30.72 0 15.872 9.728 29.184 22.016 32.256z m237.056 147.968l-86.528 125.952v-57.344h-35.84v56.832L430.592 629.76s-83.968-15.36-208.384 99.328v132.096h575.488v-124.416s-50.688-103.424-181.248-107.008z" fill="" p-id="12084"></path><path d="M466.944 653.824l20.48 31.744h47.104l20.48-31.744-18.944-31.744h-48.64l-20.48 31.744zM209.92 345.6c13.312 64.512 60.928 112.64 118.784 115.712-2.56-33.792-6.144-152.576 126.976-201.728C438.784 199.68 390.656 156.16 334.336 156.16c-64.512 0-118.272 56.832-126.976 131.072-10.24 3.584-17.92 15.36-17.92 28.672 0 14.848 8.704 27.136 20.48 29.696z m164.864 218.112l-25.088 36.864v-53.248h-33.28v52.736L257.536 482.816s-78.336-14.336-193.536 92.16v122.368s143.872-0.512 151.552 0c57.344-83.968 188.928-107.52 188.928-107.52s-17.408-12.8-29.696-26.112z" fill="" p-id="12085"></path><path d="M291.328 505.344l18.944 29.696h44.032c-18.944-29.696-23.04-59.392-23.04-59.392h-20.992l-18.944 29.696zM813.568 345.6c-13.312 64.512-60.928 112.64-118.784 115.712 2.56-33.792 6.144-152.576-127.488-201.728 17.408-60.416 65.024-103.936 121.344-103.936 64.512 0 118.272 56.832 126.976 131.072 10.24 3.584 17.92 15.36 17.92 28.672 0.512 15.36-8.192 27.648-19.968 30.208z m-164.864 218.112l25.088 36.864v-53.248h33.28v52.736l59.392-116.736s78.336-14.336 193.536 92.16v122.368s-143.872-0.512-151.552 0c-57.344-84.48-188.928-108.032-188.928-108.032s16.896-12.8 29.184-26.112z" fill="" p-id="12086"></path><path d="M732.16 505.344l-18.944 29.696h-44.032c18.944-29.696 23.04-59.392 23.04-59.392h20.992l18.944 29.696z" fill="" p-id="12087"></path></svg>',
      hidden: false,
      cache: true,
      public: {
        desktop: true,
        mobile: false,
      },
    },
    children: [
      {
        name: 'rolling',
        component: `/src/ui/views/${platform}/Rolling/RollingView.vue`,
        meta: {
          title: {
            zh: 'Rolling 进度',
            ko: '롤링현황 기록',
            en: 'Rolling Progress',
            vi: 'Tiến độ cuộn',
            th: 'ความคืบหน้า Rolling',
            my: 'ရောလ်လင် တိုးတက်မှု',
          },
          icon: '<svg t="1718269923871" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10682" width="24" height="24"><path d="M199.111111 398.222222m28.444445 0l341.333333 0q28.444444 0 28.444444 28.444445l0 170.666666q0 28.444444-28.444444 28.444445l-341.333333 0q-28.444444 0-28.444445-28.444445l0-170.666666q0-28.444444 28.444445-28.444445Z" p-id="10683"></path><path d="M824.888889 312.888889H199.111111a85.333333 85.333333 0 0 0-85.333333 85.333333v227.555556a85.333333 85.333333 0 0 0 85.333333 85.333333h625.777778a85.333333 85.333333 0 0 0 85.333333-85.333333v-227.555556a85.333333 85.333333 0 0 0-85.333333-85.333333z m28.444444 298.666667a42.666667 42.666667 0 0 1-42.666666 42.666666h-597.333334A42.666667 42.666667 0 0 1 170.666667 611.555556v-199.111112A42.666667 42.666667 0 0 1 213.333333 369.777778h597.333334a42.666667 42.666667 0 0 1 42.666666 42.666666z" p-id="10684"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'rebate',
        component: `/src/ui/views/${platform}/RebateLog/RebateLogView.vue`,
        meta: {
          title: {
            zh: '下注回扣',
            ko: '리베이트 기록',
            en: 'Bet Rebate',
            vi: 'Hoàn tiền cược',
            th: 'เงินคืนเดิมพัน',
            my: 'ပွဲစဉ်ပြန်အမ်းငွေ',
          },
          icon: '<svg t="1718346518465" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14311" width="24" height="24"><path d="M923.271624 236.476052l7.845109 13.075183a34.734508 34.734508 0 0 1-60.088992 34.677658 429.377635 429.377635 0 1 0 11.312876 408.514192l7.106077-14.951188-50.652121-22.512054a14.212155 14.212155 0 0 1-5.286922-4.0931l-1.819156-2.842431a14.155307 14.155307 0 0 1-1.307518-6.139651 369.516037 369.516037 0 1 1 31.664682-149.739268c0 49.4583-9.721114 96.642656-27.344187 139.847608l0.625335-0.85273 3.240371-2.04655 123.986843-57.985594a14.212155 14.212155 0 0 1 19.612774 8.754688l39.907732 130.922374a14.212155 14.212155 0 0 1-19.328531 17.111435l-49.799392-22.170962-7.788261 16.4861a498.84665 498.84665 0 1 1-21.886719-486.05571z m-320.796769 23.421632l-3.183523 4.604738-78.053157 135.129172H459.557421L381.504265 264.502422l-3.183523-4.604738a34.791356 34.791356 0 0 0-39.1687-10.516995l-5.116376 2.44449-4.604738 3.183523a34.791356 34.791356 0 0 0-10.516995 39.1687l2.44449 5.116376 57.928745 100.337816h-49.06036a34.734508 34.734508 0 0 0-5.684862 69.071075l5.684862 0.39794H469.221687v69.525864H330.226808a34.734508 34.734508 0 0 0-5.684862 69.014226l5.684862 0.454789H469.221687v138.93803a34.734508 34.734508 0 0 0 69.071075 5.684862l0.454789-5.684862-0.056849-138.93803h138.994879a34.734508 34.734508 0 0 0 5.684862-69.014226l-5.684862-0.454789H538.633853V469.100609h138.994879a34.734508 34.734508 0 0 0 5.684862-69.014226l-5.684862-0.454789h-76.177152l57.985593-100.394665a34.734508 34.734508 0 0 0-56.962318-39.339245z" fill="#333333" p-id="14312"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'rebate-sport-detail',
        component: `/src/ui/views/${platform}/RebateLogDetail/RebateLogDetailView.vue`,
        meta: {
          title: {
            zh: '下注回扣-体育详情',
            ko: '리베이트 기록-스포츠 상세',
            en: 'Bet Rebate-Sport Detail',
            vi: 'Hoàn tiền cược-Chi tiết thể thao',
            th: 'เงินคืนเดิมพัน-รายละเอียดกีฬา',
            my: 'ပွဲစဉ်ပြန်အမ်းငွေ-ခရမ်းအများကြီး',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'cashback',
        component: `/src/ui/views/${platform}/PlayerCashbackRecord/PlayerCashbackRecordView.vue`,
        meta: {
          title: {
            zh: '输钱返现',
            ko: '캐시백 기록',
            en: 'Loss Cashback',
            vi: 'Hoàn tiền thua',
            th: 'เงินคืนการสูญเสีย',
            my: 'ရှုံးနိမ့်မှု ပြန်အမ်းငွေ',
          },
          icon: '<svg t="1719054122032" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16974" width="24" height="24"><path d="M868.949333 580.096a301.952 301.952 0 0 0-23.850666-111.061333c-9.685333-23.082667-24.106667-43.818667-35.584-66.133334a225.066667 225.066667 0 0 1-18.176-158.805333c-59.818667 22.229333-108.288 67.413333-131.456 122.325333a199.253333 199.253333 0 0 0-14.805334 58.666667 490.325333 490.325333 0 0 1-102.528-267.52 475.733333 475.733333 0 0 1 3.072-92.16 533.76 533.76 0 0 0-136.533333 152.746667 476.714667 476.714667 0 0 0-59.733333 328.234666A313.6 313.6 0 0 1 262.314667 349.866667c-65.962667 57.344-106.112 137.386667-110.848 220.330666-4.821333 84.821333 28.202667 169.898667 90.026666 233.386667 60.757333 62.421333 147.712 102.186667 238.933334 108.928 93.44 6.912 188.501333-20.608 260.266666-75.52 68.949333-52.565333 114.602667-129.024 125.525334-210.389333 0.469333-3.797333 1.408-19.285333 2.730666-46.506667z" fill="#FF5000" p-id="16975"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'lossback',
        component: `/src/ui/views/${platform}/PlayerLossbackRecrod/PlayerLossbackRecrodView.vue`,
        meta: {
          title: {
            zh: '落选记录',
            ko: '낙첨이벤트 기록',
            en: 'lossback',
            vi: 'lossback',
            th: 'lossback',
            my: 'lossback',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'lossback_sport_detail_recrod',
        component: `/src/ui/views/${platform}/PlayerLossbackSportDetailRecrod/PlayerLossbackSportDetailRecrodView.vue`,
        meta: {
          title: {
            zh: '落选记录-体育详情',
            ko: '낙첨이벤트 기록-스포츠 상세',
            en: 'lossback-sports-detail',
            vi: 'lossback-sports-detail',
            th: 'lossback-sports-detail',
            my: 'lossback-sports-detail',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },

      {
        name: 'player_balance_change',
        component: `/src/ui/views/${platform}/PlayerBalanceChange/PlayerBalanceChangeView.vue`,
        meta: {
          title: {
            zh: '金额变动记录',
            ko: '머니변동 기록',
            en: 'Amount Change Record',
            vi: 'Ghi chép thay đổi số tiền',
            th: 'บันทึกการเปลี่ยนแปลงจำนวนเงิน',
            my: 'ငွေပမာဏ ပြောင်းလဲမှု မှတ်တမ်း',
          },
          icon: '<svg t="1718432072816" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23471" width="24" height="24"><path d="M292.318088 231.591126l-59.711844 0 0-59.717984c0-16.748419-13.586409-30.330735-30.334828-30.330735-16.756606 0-30.335852 13.581293-30.335852 30.330735l0 59.717984-59.719007 0C95.466091 231.591126 81.884798 245.178559 81.884798 261.922884c0 16.758652 13.581293 30.340968 30.331758 30.340968L171.935564 292.263853l0 59.71696c0 16.749442 13.580269 30.331758 30.335852 30.331758 16.748419 0 30.334828-13.581293 30.334828-30.331758l0-59.71696 59.711844 0c16.756606 0 30.336875-13.582316 30.336875-30.340968C322.653939 245.178559 309.074693 231.591126 292.318088 231.591126L292.318088 231.591126zM292.318088 231.591126M453.969445 107.688436l-37.265667 0L416.703777 70.422769c0-10.452029-8.476028-18.930104-18.930104-18.930104-10.455099 0-18.928057 8.478075-18.928057 18.930104l0 37.265667-37.261574 0c-10.455099 0-18.931127 8.472958-18.931127 18.924987 0 10.456122 8.475005 18.930104 18.931127 18.930104l37.261574 0 0 37.264644c0 10.453052 8.472958 18.92601 18.928057 18.92601 10.453052 0 18.930104-8.472958 18.930104-18.92601l0-37.264644 37.265667 0c10.453052 0 18.92601-8.472958 18.92601-18.930104C472.894432 116.161394 464.422497 107.688436 453.969445 107.688436L453.969445 107.688436zM453.969445 107.688436M311.309589 54.842963l-22.336683 0L288.972906 32.508326c0-6.269785-5.074565-11.346396-11.343327-11.346396-6.265691 0-11.346396 5.076612-11.346396 11.346396l0 22.334636-22.334636 0c-6.265691 0-11.346396 5.076612-11.346396 11.346396 0 6.259552 5.080705 11.34128 11.346396 11.34128l22.334636 0 0 22.334636c0 6.268761 5.080705 11.346396 11.346396 11.346396 6.267738 0 11.343327-5.076612 11.343327-11.346396L288.972906 77.530639 311.309589 77.530639c6.258528 0 11.34435-5.081728 11.34435-11.34128C322.653939 59.919575 317.574258 54.83887 311.309589 54.842963L311.309589 54.842963zM311.309589 54.842963M853.395755 614.474701c-23.59944-88.116721-74.179318-156.208402-153.206028-202.443331-6.831579-3.996003-13.932286-7.500819-21.019691-11.046568-33.313667-8.486261-77.361794-16.055642-128.554631-16.055642-51.221489 0-95.294176 7.578591-128.609889 16.070992-123.912923 57.743007-175.284838 145.710325-184.243866 274.207651-2.321877 33.371995-0.390902 66.450302 8.033961 99.139753 13.150482 51.55304 58.509462 90.146956 112.968685 90.053835 128.249686-0.294712 256.59761 0 384.852412-0.195451 41.206412-0.099261 72.930887-18.573994 95.949091-52.232514 11.702506-17.118855 17.211976-36.558564 20.310541-56.966319C867.329064 707.807203 865.775689 660.797634 853.395755 614.474701L853.395755 614.474701zM637.029348 734.404925 584.992285 734.404925c-0.677427 0-1.159404 0.580213-1.159404 1.160427l0 24.951225-0.289595 0c0.387832 2.030235 0.677427 4.159731 0.677427 6.289227 0 17.89452-14.798001 32.491953-32.983139 32.491953-18.182068 0-32.983139-14.498173-32.983139-32.491953 0-2.227733 0.293688-4.257969 0.683567-6.289227l-0.683567 0L518.254435 735.561258c0-0.668218-0.575097-1.156334-1.157357-1.156334l-51.552017 0-0.098237 0c-14.508406 0-26.407387-11.607339-26.407387-26.017508 0-14.415286 11.80586-26.022625 26.407387-26.022625l0.098237 0 51.548947 0c0.677427 0 1.16145-0.575097 1.16145-1.156334l0-23.510413c0-0.673334-0.575097-1.154287-1.16145-1.154287l-51.548947 0 0-0.094144-0.098237 0c-14.508406 0-26.407387-11.613479-26.407387-26.018531 0-14.321142 11.80586-26.022625 26.407387-26.022625l0.098237 0 47.197857 0c0.491186 0 0.973162-0.284479 1.067306-0.767478 0.387832-1.071399 0.869809-2.034329 1.448999-3.003398 0.291642-0.481976 0.192381-1.06219-0.190335-1.450022l-58.421457-57.551649c-7.351417-7.152896-4.933349-21.278587 5.318112-31.337666 10.252484-10.058057 24.572603-12.477148 31.824759-5.220898l56.966319 56.193724c0.481976 0.481976 1.258664 0.481976 1.74064 0l52.712444-55.323916c8.320486-8.995867 25.24696-6.769157 35.595635 3.481281 10.251461 10.254531 15.377192 19.537946 5.220898 30.854667l-61.901715 62.388808c-0.289595 0.284479-0.383739 0.575097-0.383739 0.962929 0.094144 0.580213 0.575097 1.063213 1.16145 1.063213l51.936779 0 0 0.093121c14.508406 0.099261 26.209889 11.705576 26.209889 26.027741 0 14.311932-11.702506 25.914154-26.209889 25.914154L584.992285 656.73307c-0.677427 0-1.159404 0.58533-1.159404 1.160427l0 23.505296c0 0.678451 0.57919 1.16145 1.159404 1.16145l52.037063 0 0 0.093121c14.508406 0.098237 26.207843 11.7066 26.207843 26.017508C663.237191 722.797586 651.537754 734.306687 637.029348 734.404925L637.029348 734.404925zM637.029348 734.404925M402.353983 367.29456c34.767782-10.414166 86.447712-21.586601 148.261422-21.586601 61.654075 0 113.226558 11.111036 147.983084 21.507807 6.238062-9.143223 11.384259-18.995595 15.233929-29.658424 3.481281-9.675341 5.414302-19.832658 8.122988-29.7935 6.185874-23.112348 0.192381-43.039149-17.700092-58.318104-24.183747-20.600136-51.744398-23.024343-80.76735-10.934005-2.028189 0.869809-3.38202 1.455139-5.314018-0.481976-37.334229-35.303993-97.305992-35.692849-134.930839-0.771571-1.74064 1.64138-2.994188 2.030235-5.319135 0.963953-15.282024-7.060799-31.238406-8.506727-47.584666-5.1288-31.053188 6.386441-56.679794 32.791782-52.136323 68.86837C381.272894 326.216061 389.235224 347.916249 402.353983 367.29456L402.353983 367.29456zM402.353983 367.29456" fill="#272636" p-id="23472"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'player_coupons',
        component: `/src/ui/views/${platform}/PlayerCoupons/PlayerCouponsView.vue`,
        meta: {
          title: {
            zh: '代金券记录',
            ko: '쿠폰발송 기록',
            en: 'Voucher Record',
            vi: 'Ghi chép phiếu giảm giá',
            th: 'บันทึกบัตรกำนัล',
            my: 'ဗောက်ချာ မှတ်တမ်း',
          },
          icon: '<svg t="1719238280084" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6656" width="24" height="24"><path d="M134 399.359c0-14.746 2.457-25.257 7.371-31.539 4.918-6.281 15.84-9.422 32.77-9.422H279V768h-45.059c-12.015 0-23.89-0.137-35.632-0.41-11.743-0.274-19.797-0.41-24.168-0.41-14.746 0.547-25.121-1.91-31.129-7.371-6.008-5.461-9.012-15.84-9.012-31.129V610.715c0-6.008 0.957-10.516 2.867-13.52 1.91-3.004 5.871-5.05 11.879-6.14 2.184 0 5.188-0.821 9.012-2.461 3.82-1.637 7.644-4.231 11.469-7.782 3.82-3.55 7.097-8.191 9.828-13.925 2.73-5.735 4.097-12.699 4.097-20.891 0-12.558-3.414-22.391-10.242-29.492-6.824-7.098-14.062-11.195-21.707-12.285-6.008-1.094-10.375-2.867-13.105-5.324-2.731-2.461-4.098-6.692-4.098-12.7v-86.836z m67.992-77.824v-21.297c0-10.926 4.235-21.027 12.699-30.312 8.465-9.285 17.614-13.926 27.442-13.926h113.051v65.535H201.992z m667.649 177.766c-4.368 1.094-7.508 3.414-9.418 6.965-1.914 3.55-2.868 7.507-2.868 11.879 0 4.367 0.954 8.601 2.868 12.695 1.91 4.098 5.05 6.965 9.418 8.601 4.371 1.641 7.785 4.918 10.242 9.832a38.804 38.804 0 0 1 4.094 15.567c0.273 5.461-0.411 10.648-2.047 15.562-1.637 4.918-4.098 8.465-7.371 10.653-10.926 6.55-16.387 13.925-16.387 22.117 0 8.191 5.461 16.383 16.387 24.574 2.183 1.641 4.23 4.645 6.14 9.012 1.914 4.371 2.867 8.738 2.867 13.109 0 4.367-1.089 8.192-3.273 11.469-2.188 3.273-6.008 4.914-11.469 4.914h-44.238c-3.277 0-5.051-0.273-5.324-0.82-0.274-0.547 0.136-1.5 1.226-2.868 1.094-1.363 2.457-2.867 4.098-4.503 1.637-1.641 3.004-3.551 4.094-5.735 2.734-7.648 2.734-14.199 0-19.66-2.731-5.465-7.371-10.105-13.926-13.93-4.367-2.183-7.508-5.597-9.418-10.238-1.914-4.641-2.731-9.422-2.461-14.336 0.273-4.914 1.23-9.285 2.867-13.105 1.641-3.825 4.098-6.555 7.375-8.196 4.367-1.636 7.645-4.64 9.828-9.011 2.188-4.368 3.278-9.008 3.278-13.926 0-4.914-0.817-9.418-2.457-13.516-1.637-4.097-4.094-6.965-7.371-8.601-4.372-2.184-7.786-5.461-10.243-9.832-2.457-4.368-3.683-9.282-3.683-14.743 0-5.464 1.09-10.789 3.273-15.976 2.188-5.188 5.735-9.422 10.653-12.695 3.277-2.188 6.007-5.192 8.191-9.012 2.184-3.824 3.414-7.922 3.687-12.289 0.274-4.371-0.546-8.602-2.461-12.699-1.91-4.094-5.324-7.508-10.238-10.239-5.461-2.73-9.422-6.691-11.879-11.879-2.457-5.187-3.687-10.511-3.687-15.972s1.23-10.653 3.687-15.567 5.871-8.738 10.243-11.468c9.281-4.914 14.335-11.606 15.152-20.071 0.82-8.465 0.137-16.246-2.047-23.347-1.637-5.461-4.914-10.375-9.832-14.746-4.914-4.368-11.195-6.551-18.84-6.551H405.156V256h461.207c3.825 0 7.102 1.367 9.832 4.098 2.731 2.73 4.504 6.004 5.325 9.828 0.82 3.824 0.546 7.781-0.821 11.879-1.363 4.097-3.957 7.507-7.781 10.238-3.277 2.734-6.145 6.281-8.602 10.652-2.457 4.367-3.824 8.875-4.093 13.516-0.274 4.641 0.406 9.285 2.047 13.926 1.636 4.644 4.64 8.054 9.011 10.242 6.008 3.277 10.512 7.781 13.516 13.516 3.004 5.734 4.504 11.468 4.504 17.203 0 5.734-1.5 11.058-4.504 15.972-3.004 4.918-7.238 8.465-12.699 10.653-6.008 2.183-10.375 5.324-13.106 9.418-2.73 4.097-4.234 8.601-4.504 13.519-0.273 4.914 0.817 9.692 3.274 14.336 2.461 4.641 6.418 8.602 11.879 11.879 5.461 3.277 9.421 7.645 11.879 13.105 2.457 5.461 3.55 10.922 3.277 16.383-0.274 5.461-1.637 10.516-4.098 15.157-2.457 4.644-6.14 7.238-11.058 7.781z m-106.496-12.285c-6.551 1.636-11.606 4.777-15.153 9.418-3.551 4.644-5.465 9.421-5.734 14.336-0.274 4.918 1.09 9.832 4.094 14.746 3.003 4.918 7.511 8.464 13.515 10.652 5.465 2.184 9.559 5.461 12.289 9.828 2.731 4.371 4.235 9.012 4.508 13.926 0.27 4.918-0.684 9.558-2.867 13.926-2.188 4.371-5.465 7.648-9.832 9.832-13.653 6.554-20.754 14.472-21.301 23.758-0.543 9.285 4.645 16.656 15.566 22.117 4.915 2.183 8.875 5.597 11.879 10.242 3.004 4.641 4.641 9.555 4.914 14.742 0.274 5.191-0.683 9.832-2.867 13.93-2.183 4.093-5.734 6.961-10.648 8.601-6.555 1.637-11.606 4.641-15.156 9.008-3.551 4.371-5.461 9.012-5.735 13.93-0.273 4.914 1.094 9.828 4.098 14.746 3.004 4.914 7.781 9.008 14.336 12.285 4.367 2.184 7.508 5.598 9.418 10.242 1.914 4.641 2.597 9.145 2.051 13.516-0.547 4.367-2.051 8.328-4.508 11.879S760.141 768 755.773 768H327.332V358.398h433.356c4.371 0 7.781 1.778 10.242 5.329 2.457 3.546 3.82 7.507 4.093 11.875 0.274 4.371-0.683 8.738-2.867 13.109-2.183 4.367-5.734 7.371-10.648 9.012-4.914 1.636-8.875 4.367-11.879 8.191-3.004 3.824-4.777 8.055-5.324 12.695-0.547 4.645 0.547 9.149 3.277 13.52 2.73 4.367 7.371 7.644 13.926 9.828 4.914 2.188 8.875 5.461 11.879 9.832 3.004 4.367 4.64 8.875 4.914 13.516 0.273 4.644-0.821 9.011-3.278 13.109-2.457 4.094-6.418 6.961-11.878 8.602z m-197.426 54.886c-2.731 0-5.598-0.273-8.602-0.82-3.004-0.547-3.687-2.184-2.047-4.914 0.543-1.094 3.141-4.918 7.782-11.469 4.64-6.554 9.828-13.519 15.562-20.89a1472.754 1472.754 0 0 0 15.977-20.891c4.914-6.555 7.918-10.648 9.011-12.289 2.731-4.367 1.09-9.555-4.914-15.563-1.093-1.093-3.277-2.73-6.554-4.914-3.278-2.187-6.282-3.824-9.012-4.918-4.371-1.636-7.508-1.91-9.422-0.82-1.91 1.094-4.23 3.551-6.961 7.375-1.094 1.637-3.824 5.598-8.195 11.879-4.367 6.281-9.008 12.969-13.926 20.07a1586.11 1586.11 0 0 1-13.516 19.25c-4.097 5.735-6.418 9.149-6.964 10.242-1.09 2.184-3.137 3.004-6.141 2.458-3.004-0.547-5.055-1.915-6.145-4.098-0.547-1.09-3.004-4.231-7.375-9.422-4.367-5.188-9.011-11.059-13.925-17.609a631.407 631.407 0 0 0-14.336-18.434c-4.641-5.734-7.782-9.695-9.422-11.879-4.914-9.285-10.102-12.289-15.563-9.012-3.824 2.184-7.238 4.508-10.242 6.965-3.004 2.457-5.871 4.504-8.601 6.145-5.461 3.82-6.278 8.738-2.458 14.746 9.286 10.922 17.477 21.023 24.579 30.308a2749.182 2749.182 0 0 1 17.203 22.118c5.461 7.101 8.738 11.195 9.828 12.289 1.094 2.183 0 3.277-3.278 3.277h-9.828c-2.73 0-6.691 0.137-11.879 0.41-5.187 0.274-9.968 0.137-14.335-0.41-4.372 0-7.918 1.094-10.649 3.277-2.73 2.184-3.551 4.914-2.461 8.192 0.547 2.183 0.82 5.461 0.82 9.828v9.832c0 2.73 0.821 4.234 2.458 4.508 1.64 0.269 3.55 0.406 5.734 0.406h47.516c6.554 0 9.828 1.367 9.828 4.098v15.566c0 2.731-0.543 4.094-1.637 4.094h-54.887c-3.277-0.547-5.461 0.273-6.554 2.457-1.09 2.183-1.911 4.644-2.458 7.375-0.546 2.73-0.546 5.324 0 7.781 0.547 2.457 0.821 4.504 0.821 6.145 0 7.097 3.551 10.648 10.648 10.648h49.153c2.73 0 4.371 0.41 4.914 1.231 0.546 0.816 0.82 2.593 0.82 5.324 0.547 2.73 0.684 7.644 0.41 14.746-0.273 7.098-0.41 11.742-0.41 13.926 0 6.007 3.551 9.011 10.648 9.011h26.215c4.371 0 6.555-1.367 6.555-4.097v-32.766c0-5.465 2.457-8.195 7.371-8.195h7.375c3.824 0 8.055-0.137 12.695-0.407 4.645-0.273 9.149-0.41 13.52-0.41h10.648c7.645 0 11.469-2.73 11.469-8.191v-18.023c0-4.915-2.73-7.376-8.191-7.376h-47.516c-5.461 1.094-8.191 0-8.191-3.273 0-1.641-0.137-3.687-0.411-6.144a64.219 64.219 0 0 1-0.406-6.965c0-2.184 0.953-3.825 2.867-4.914a12.158 12.158 0 0 1 6.141-1.641h48.336c5.461 0 8.191-1.91 8.191-5.734V551.73c0-2.183-0.957-4.367-2.867-6.554-1.914-2.184-4.234-3.274-6.965-3.274h-27.851z" fill="#000000" p-id="6657"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'sms_log',
        component: `/src/ui/views/${platform}/SmsLog/SmsLogView.vue`,
        meta: {
          title: {
            zh: '短信发送记录',
            ko: '시스템문자 기록',
            en: 'SMS Sending Record',
            vi: 'Ghi chép gửi SMS',
            th: 'บันทึกการส่ง SMS',
            my: 'SMS ပေးပို့မှု မှတ်တမ်း',
          },
          icon: '<svg t="1719036427064" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11692" width="24" height="24"><path d="M702.229 505.85l257.369 208.406V297.444zM599.854 588.749c-25.344 20.528-56.423 30.791-87.498 30.791-31.08 0-62.155-10.264-87.513-30.796l-53.778-43.556L65.846 792.386c2.945 22.208 13.831 41.923 29.75 56.193 7.592 6.805 16.341 12.319 25.868 16.329 10.846 4.566 22.712 7.164 35.207 7.164h711.225c15.817 0 30.632-4.139 43.612-11.24 9.122-4.99 17.365-11.399 24.295-19.056 12.221-13.502 20.449-30.628 22.931-49.554l-305.078-247.04-53.802 43.567zM64.969 297.272v417.157l257.529-208.577z" fill="#4D4D4D" p-id="11693"></path><path d="M419.633 505.853l43.688 35.383c28.408 23.005 69.652 23.005 98.061 0l43.699-35.386 48.574-39.333 303.38-245.664c-9.591-40.379-45.87-70.543-89.139-70.543H156.671c-43.219 0-79.46 30.093-89.103 70.4l303.497 245.807 48.568 39.336z" fill="#4D4D4D" p-id="11694"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'player_login_record',
        component: `/src/ui/views/${platform}/PlayerLoginRecord/PlayerLoginRecordView.vue`,
        meta: {
          title: {
            zh: '登录记录',
            ko: '회원 로그인기록',
            en: 'Login Record',
            vi: 'Ghi chép đăng nhập',
            th: 'บันทึกการเข้าสู่ระบบ',
            my: 'လော့ဂ်အင် မှတ်တမ်း',
          },
          icon: '<svg t="1719054122032" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16974" width="24" height="24"><path d="M868.949333 580.096a301.952 301.952 0 0 0-23.850666-111.061333c-9.685333-23.082667-24.106667-43.818667-35.584-66.133334a225.066667 225.066667 0 0 1-18.176-158.805333c-59.818667 22.229333-108.288 67.413333-131.456 122.325333a199.253333 199.253333 0 0 0-14.805334 58.666667 490.325333 490.325333 0 0 1-102.528-267.52 475.733333 475.733333 0 0 1 3.072-92.16 533.76 533.76 0 0 0-136.533333 152.746667 476.714667 476.714667 0 0 0-59.733333 328.234666A313.6 313.6 0 0 1 262.314667 349.866667c-65.962667 57.344-106.112 137.386667-110.848 220.330666-4.821333 84.821333 28.202667 169.898667 90.026666 233.386667 60.757333 62.421333 147.712 102.186667 238.933334 108.928 93.44 6.912 188.501333-20.608 260.266666-75.52 68.949333-52.565333 114.602667-129.024 125.525334-210.389333 0.469333-3.797333 1.408-19.285333 2.730666-46.506667z" fill="#FF5000" p-id="16975"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'player_ips',
        component: `/src/ui/views/${platform}/PlayerIP/PlayerIpView.vue`,
        meta: {
          title: {
            zh: '玩家IP',
            ko: '회원 IP',
            en: 'Player IP',
            vi: 'IP của người chơi',
            th: 'IP ของผู้เล่น',
            my: 'လော့ဂ်အင် မှတ်တမ်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      // {
      //   name: 'common_search',
      //   component: `/src/ui/views/${platform}/__BaseAdmin/Developing/DevelopingView.vue`,
      //   meta: {
      //     title: { zh: '通用查询页', en: 'Common Search', ko: '통합검색 페이지' },
      //     icon: '<svg t="1719054122032" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16974" width="24" height="24"><path d="M868.949333 580.096a301.952 301.952 0 0 0-23.850666-111.061333c-9.685333-23.082667-24.106667-43.818667-35.584-66.133334a225.066667 225.066667 0 0 1-18.176-158.805333c-59.818667 22.229333-108.288 67.413333-131.456 122.325333a199.253333 199.253333 0 0 0-14.805334 58.666667 490.325333 490.325333 0 0 1-102.528-267.52 475.733333 475.733333 0 0 1 3.072-92.16 533.76 533.76 0 0 0-136.533333 152.746667 476.714667 476.714667 0 0 0-59.733333 328.234666A313.6 313.6 0 0 1 262.314667 349.866667c-65.962667 57.344-106.112 137.386667-110.848 220.330666-4.821333 84.821333 28.202667 169.898667 90.026666 233.386667 60.757333 62.421333 147.712 102.186667 238.933334 108.928 93.44 6.912 188.501333-20.608 260.266666-75.52 68.949333-52.565333 114.602667-129.024 125.525334-210.389333 0.469333-3.797333 1.408-19.285333 2.730666-46.506667z" fill="#FF5000" p-id="16975"></path></svg>',
      //     hidden: false,
      //     cache: true,
      //     needLogin: false,
      //     public: {
      //       desktop: true,
      //       mobile: true,
      //     },
      //   },
      // },
    ],
  },

  {
    name: 'csr_agent',
    meta: {
      title: {
        zh: '代理商CSR',
        ko: '파트너CSR',
        en: 'Agent CSR',
        vi: 'CSR đại lý',
        th: 'CSR ตัวแทน',
        my: 'ကိုယ်စားလှယ် CSR',
      },
      icon: '<svg t="1706775114716" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12083" width="32" height="32"><path d="M379.392 481.792c14.848 71.68 69.12 124.928 134.144 124.928 64.512 0 118.784-53.248 134.144-124.928 13.312-2.048 24.064-15.36 24.064-32.256 0-15.36-9.216-28.16-21.504-31.744-9.728-79.36-67.072-140.288-136.704-140.288s-126.976 61.44-136.704 141.312c-11.264 4.096-19.456 16.384-19.456 30.72 0 15.872 9.728 29.184 22.016 32.256z m237.056 147.968l-86.528 125.952v-57.344h-35.84v56.832L430.592 629.76s-83.968-15.36-208.384 99.328v132.096h575.488v-124.416s-50.688-103.424-181.248-107.008z" fill="" p-id="12084"></path><path d="M466.944 653.824l20.48 31.744h47.104l20.48-31.744-18.944-31.744h-48.64l-20.48 31.744zM209.92 345.6c13.312 64.512 60.928 112.64 118.784 115.712-2.56-33.792-6.144-152.576 126.976-201.728C438.784 199.68 390.656 156.16 334.336 156.16c-64.512 0-118.272 56.832-126.976 131.072-10.24 3.584-17.92 15.36-17.92 28.672 0 14.848 8.704 27.136 20.48 29.696z m164.864 218.112l-25.088 36.864v-53.248h-33.28v52.736L257.536 482.816s-78.336-14.336-193.536 92.16v122.368s143.872-0.512 151.552 0c57.344-83.968 188.928-107.52 188.928-107.52s-17.408-12.8-29.696-26.112z" fill="" p-id="12085"></path><path d="M291.328 505.344l18.944 29.696h44.032c-18.944-29.696-23.04-59.392-23.04-59.392h-20.992l-18.944 29.696zM813.568 345.6c-13.312 64.512-60.928 112.64-118.784 115.712 2.56-33.792 6.144-152.576-127.488-201.728 17.408-60.416 65.024-103.936 121.344-103.936 64.512 0 118.272 56.832 126.976 131.072 10.24 3.584 17.92 15.36 17.92 28.672 0.512 15.36-8.192 27.648-19.968 30.208z m-164.864 218.112l25.088 36.864v-53.248h33.28v52.736l59.392-116.736s78.336-14.336 193.536 92.16v122.368s-143.872-0.512-151.552 0c-57.344-84.48-188.928-108.032-188.928-108.032s16.896-12.8 29.184-26.112z" fill="" p-id="12086"></path><path d="M732.16 505.344l-18.944 29.696h-44.032c18.944-29.696 23.04-59.392 23.04-59.392h20.992l18.944 29.696z" fill="" p-id="12087"></path></svg>',
      hidden: false,
      cache: true,
      public: {
        desktop: true,
        mobile: false,
      },
    },
    children: [
      {
        name: 'agent_balance_record',
        component: `/src/ui/views/${platform}/AgentBalanceRecord/AgentBalanceRecordView.vue`,
        meta: {
          title: {
            zh: '金额修改记录',
            ko: '머니변동 기록',
            en: 'Amount Modification Record',
            vi: 'Ghi chép sửa đổi số tiền',
            th: 'บันทึกการแก้ไขจำนวนเงิน',
            my: 'ငွေပမာဏ ပြင်ဆင်ခြင်း မှတ်တမ်း',
          },
          icon: '<svg t="1719054122032" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16974" width="24" height="24"><path d="M868.949333 580.096a301.952 301.952 0 0 0-23.850666-111.061333c-9.685333-23.082667-24.106667-43.818667-35.584-66.133334a225.066667 225.066667 0 0 1-18.176-158.805333c-59.818667 22.229333-108.288 67.413333-131.456 122.325333a199.253333 199.253333 0 0 0-14.805334 58.666667 490.325333 490.325333 0 0 1-102.528-267.52 475.733333 475.733333 0 0 1 3.072-92.16 533.76 533.76 0 0 0-136.533333 152.746667 476.714667 476.714667 0 0 0-59.733333 328.234666A313.6 313.6 0 0 1 262.314667 349.866667c-65.962667 57.344-106.112 137.386667-110.848 220.330666-4.821333 84.821333 28.202667 169.898667 90.026666 233.386667 60.757333 62.421333 147.712 102.186667 238.933334 108.928 93.44 6.912 188.501333-20.608 260.266666-75.52 68.949333-52.565333 114.602667-129.024 125.525334-210.389333 0.469333-3.797333 1.408-19.285333 2.730666-46.506667z" fill="#FF5000" p-id="16975"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'agent_add_coupon_record',
        component: `/src/ui/views/${platform}/__BaseAdmin/Developing/DevelopingView.vue`,
        meta: {
          title: {
            zh: '购买coupon记录',
            ko: '쿠폰구매 기록',
            en: 'Coupon Purchase Record',
            vi: 'Ghi chép mua coupon',
            th: 'บันทึกการซื้อคูปอง',
            my: 'ကူပွန် ဝယ်ယူမှု မှတ်တမ်း',
          },
          icon: '<svg t="1719054122032" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16974" width="24" height="24"><path d="M868.949333 580.096a301.952 301.952 0 0 0-23.850666-111.061333c-9.685333-23.082667-24.106667-43.818667-35.584-66.133334a225.066667 225.066667 0 0 1-18.176-158.805333c-59.818667 22.229333-108.288 67.413333-131.456 122.325333a199.253333 199.253333 0 0 0-14.805334 58.666667 490.325333 490.325333 0 0 1-102.528-267.52 475.733333 475.733333 0 0 1 3.072-92.16 533.76 533.76 0 0 0-136.533333 152.746667 476.714667 476.714667 0 0 0-59.733333 328.234666A313.6 313.6 0 0 1 262.314667 349.866667c-65.962667 57.344-106.112 137.386667-110.848 220.330666-4.821333 84.821333 28.202667 169.898667 90.026666 233.386667 60.757333 62.421333 147.712 102.186667 238.933334 108.928 93.44 6.912 188.501333-20.608 260.266666-75.52 68.949333-52.565333 114.602667-129.024 125.525334-210.389333 0.469333-3.797333 1.408-19.285333 2.730666-46.506667z" fill="#FF5000" p-id="16975"></path></svg>',
          hidden: true,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'agent_login_record',
        component: `/src/ui/views/${platform}/AgentLoginRecord/AgentLoginRecordView.vue`,
        meta: {
          title: {
            zh: '代理商登录记录',
            ko: '파트너 로그인 기록',
            en: 'Agent Login Record',
            vi: 'Ghi chép đăng nhập đại lý',
            th: 'บันทึกการเข้าสู่ระบบตัวแทน',
            my: 'ကိုယ်စားလှယ် လော့ဂ်အင် မှတ်တမ်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },

  {
    name: 'betting',
    meta: {
      title: {
        zh: '游戏记录',
        ko: '게임기록',
        en: 'Game Record',
        vi: 'Ghi chép trò chơi',
        th: 'บันทึกเกม',
        my: 'ဂိမ်းမှတ်တမ်း',
      },
      icon: '<svg t="1717037731060" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6324" width="24" height="24"><path d="M362.91584 943.935488c-9.75872-5.502976-13.832192-13.647872-13.697024-24.317952 0.425984-33.45408 0.78848-66.910208 1.202176-100.364288 2.451456-197.95968 4.909056-395.91936 7.370752-593.881088 0.190464-15.44192 9.2672-24.469504 25.116672-24.418304 31.084544 0.100352 62.164992 0.456704 93.249536 0.714752 150.665216 1.245184 301.330432 2.494464 451.995648 3.743744 20.475904 0.169984 28.895232 8.603648 28.643328 28.99968-2.607104 212.609024-5.246976 425.218048-7.876608 637.827072-0.221184 17.8176-0.421888 35.6352-0.679936 53.4528-0.212992 14.96064-9.750528 24.246272-24.854528 24.123392-183.134208-1.507328-366.270464-3.028992-549.40672-4.605952-3.688448-0.03072-7.3728-0.831488-11.063296-1.273856z m251.031552-167.593984l71.344128 0.817152c-11.4688-41.490432-22.398976-99.203072-21.53472-113.240064 4.982784 6.477824 9.703424 13.28128 15.09376 19.511296 27.877376 32.223232 70.4512 46.759936 111.650816 31.264768 39.84384-14.987264 64.503808-43.307008 69.224448-86.355968 3.684352-33.57696-9.230336-62.367744-32.229376-85.639168-20.391936-20.635648-42.979328-39.165952-65.161216-57.9584-38.815744-32.88064-71.712768-70.43072-94.715904-116.133888-2.267136-4.503552-4.749312-8.89856-7.479296-13.993984-1.148928 2.023424-1.820672 3.190784-2.476032 4.364288-15.939584 28.465152-34.43712 55.031808-57.440256 78.336-23.87968 24.195072-50.978816 44.509184-77.828096 65.13664-16.963584 13.031424-34.14016 25.847808-47.372288 42.973184-24.666112 31.924224-34.820096 66.875392-21.266432 106.366976 19.085312 55.611392 84.989952 82.978816 137.3184 57.229312 19.480576-9.586688 34.504704-24.322048 47.654912-41.224192 0.821248-1.058816 1.824768-1.97632 3.897344-4.1984-8.11008 38.823936-13.662208 76.343296-28.680192 112.744448z" p-id="6325"></path><path d="M385.253376 135.60832c-15.915008 5.750784-30.808064 11.155456-45.7216 16.515072-41.0624 14.76608-82.126848 29.526016-123.19744 44.261376-34.709504 12.455936-50.874368 47.372288-37.947392 82.3808 39.161856 106.059776 78.444544 212.078592 117.567488 318.154752 12.972032 35.170304 25.608192 70.463488 38.387712 105.70752 0.647168 1.785856 1.183744 3.612672 2.33472 7.145472-13.45536-13.625344-25.67168-25.964544-37.851136-38.336512-84.850688-86.218752-169.689088-172.447744-254.543872-258.664448-26.599424-27.027456-26.281984-65.564672 1.019904-92.104704 73.957376-71.899136 147.984384-143.726592 222.005248-215.558144 24.834048-24.098816 60.848128-25.022464 86.372352-1.687552 10.778624 9.854976 20.512768 20.840448 31.574016 32.186368z" p-id="6326"></path><path d="M324.5568 627.775488c-11.081728-30.138368-22.14912-60.284928-33.241088-90.4192-29.861888-81.137664-59.10528-162.5088-89.878528-243.300352-13.973504-36.691968 3.360768-75.446272 41.295872-88.969216 96.937984-34.553856 193.384448-70.486016 290.084864-105.70752 31.234048-11.378688 65.763328 3.950592 78.053376 34.719744 6.023168 15.079424 10.99776 30.574592 16.738304 46.700544-2.574336 0.0512-4.624384 0.147456-6.674432 0.129024-74.620928-0.784384-149.241856-1.5872-223.862784-2.36544-28.448768-0.29696-52.625408 14.86848-62.22848 40.138752-2.811904 7.395328-4.007936 15.80032-4.124672 23.76704-1.830912 126.072832-3.364864 252.145664-4.97664 378.222592-0.03072 2.330624-0.155648 4.657152-0.233472 6.987776l-0.95232 0.096256z" p-id="6327"></path></svg>',
      hidden: false,
      cache: true,
      public: {
        desktop: true,
        mobile: false,
      },
    },
    children: [
      {
        path: 'sports',
        name: 'betting_sports',
        component: `/src/ui/views/${platform}/BettingSports/BettingSportsView.vue`,
        meta: {
          title: { zh: '体育', ko: '스포츠', en: 'Sports', vi: 'Thể thao', th: 'กีฬา', my: 'အားကစား' },
          icon: '<svg t="1717054205258" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23238" width="24" height="24"><path d="M133.333333 400.96h8.96a400 400 0 0 1 244.213334 82.72 5.333333 5.333333 0 0 0 6.613333 0c15.146667-12.906667 80.373333-68.106667 120.853333-95.413333a5.333333 5.333333 0 0 0 1.866667-6.346667 401.226667 401.226667 0 0 1 10.666667-331.306667 5.333333 5.333333 0 0 0-4.266667-7.946666H512a469.333333 469.333333 0 0 0-456.426667 359.786666 5.333333 5.333333 0 0 0 6.346667 6.453334A402.026667 402.026667 0 0 1 133.333333 400.96zM887.093333 629.92a401.333333 401.333333 0 0 1-330.986666-174.026667 5.333333 5.333333 0 0 0-7.36-1.386666A883.306667 883.306667 0 0 0 448 534.186667a5.333333 5.333333 0 0 0-0.426667 7.36 402.24 402.24 0 0 1 82.773334 364.693333 390.24 390.24 0 0 1-24.64 67.466667 5.333333 5.333333 0 0 0 4.693333 7.626666h1.6a469.333333 469.333333 0 0 0 454.4-351.52 5.333333 5.333333 0 0 0-6.186667-6.506666 400 400 0 0 1-71.52 6.613333z" p-id="23239"></path><path d="M937.066667 313.013333a5.333333 5.333333 0 0 0-5.333334-3.04q-37.333333 4.746667-73.493333 12.426667a873.493333 873.493333 0 0 0-235.893333 87.2 5.333333 5.333333 0 0 0-1.813334 7.84 326.72 326.72 0 0 0 266.666667 137.813333c5.76 0 11.52 0 17.226667-0.48a317.813333 317.813333 0 0 0 72.373333-12 5.333333 5.333333 0 0 0 3.893333-4.906666c0.48-8.533333 0.746667-17.173333 0.746667-25.866667a466.88 466.88 0 0 0-44.373333-198.986667zM812.48 256.426667c24.32-4.853333 48.586667-10.666667 73.333333-15.146667a5.333333 5.333333 0 0 0 3.413334-8.373333 469.76 469.76 0 0 0-274.453334-178.933334l-5.866666 2.453334A330.666667 330.666667 0 0 0 577.493333 122.666667a326.826667 326.826667 0 0 0 2.506667 217.76 5.333333 5.333333 0 0 0 7.733333 2.72 740.426667 740.426667 0 0 1 224.746667-86.72zM142.186667 475.52c-7.84 0-15.573333 0-23.253334 0.853333a322.08 322.08 0 0 0-72.106666 13.386667 5.333333 5.333333 0 0 0-3.84 4.96Q42.666667 503.36 42.666667 512a467.04 467.04 0 0 0 109.76 301.44 5.333333 5.333333 0 0 0 8.96-1.386667q14.72-34.4 32-67.52a960 960 0 0 1 139.413333-200.213333 5.333333 5.333333 0 0 0-0.8-7.893333 324.533333 324.533333 0 0 0-189.813333-60.906667zM246.773333 804q-16 33.6-29.44 68.373333a5.333333 5.333333 0 0 0 1.653334 6.133334 467.52 467.52 0 0 0 198.773333 93.333333 5.333333 5.333333 0 0 0 5.76-2.506667 326.613333 326.613333 0 0 0-28.266667-373.653333 5.333333 5.333333 0 0 0-8.16 0 881.92 881.92 0 0 0-140.32 208.32z" p-id="23240"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        path: 'live',
        name: 'betting_live',
        component: `/src/ui/views/${platform}/BettingLive/BettingLiveView.vue`,
        meta: {
          title: {
            zh: '棋牌',
            ko: '카지노',
            en: 'Board Games',
            vi: 'Cờ bạc',
            th: 'เกมกระดาน',
            my: 'စားပွဲထိုးဂိမ်းများ',
          },
          icon: '<svg t="1717037731060" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6324" width="24" height="24"><path d="M362.91584 943.935488c-9.75872-5.502976-13.832192-13.647872-13.697024-24.317952 0.425984-33.45408 0.78848-66.910208 1.202176-100.364288 2.451456-197.95968 4.909056-395.91936 7.370752-593.881088 0.190464-15.44192 9.2672-24.469504 25.116672-24.418304 31.084544 0.100352 62.164992 0.456704 93.249536 0.714752 150.665216 1.245184 301.330432 2.494464 451.995648 3.743744 20.475904 0.169984 28.895232 8.603648 28.643328 28.99968-2.607104 212.609024-5.246976 425.218048-7.876608 637.827072-0.221184 17.8176-0.421888 35.6352-0.679936 53.4528-0.212992 14.96064-9.750528 24.246272-24.854528 24.123392-183.134208-1.507328-366.270464-3.028992-549.40672-4.605952-3.688448-0.03072-7.3728-0.831488-11.063296-1.273856z m251.031552-167.593984l71.344128 0.817152c-11.4688-41.490432-22.398976-99.203072-21.53472-113.240064 4.982784 6.477824 9.703424 13.28128 15.09376 19.511296 27.877376 32.223232 70.4512 46.759936 111.650816 31.264768 39.84384-14.987264 64.503808-43.307008 69.224448-86.355968 3.684352-33.57696-9.230336-62.367744-32.229376-85.639168-20.391936-20.635648-42.979328-39.165952-65.161216-57.9584-38.815744-32.88064-71.712768-70.43072-94.715904-116.133888-2.267136-4.503552-4.749312-8.89856-7.479296-13.993984-1.148928 2.023424-1.820672 3.190784-2.476032 4.364288-15.939584 28.465152-34.43712 55.031808-57.440256 78.336-23.87968 24.195072-50.978816 44.509184-77.828096 65.13664-16.963584 13.031424-34.14016 25.847808-47.372288 42.973184-24.666112 31.924224-34.820096 66.875392-21.266432 106.366976 19.085312 55.611392 84.989952 82.978816 137.3184 57.229312 19.480576-9.586688 34.504704-24.322048 47.654912-41.224192 0.821248-1.058816 1.824768-1.97632 3.897344-4.1984-8.11008 38.823936-13.662208 76.343296-28.680192 112.744448z" p-id="6325"></path><path d="M385.253376 135.60832c-15.915008 5.750784-30.808064 11.155456-45.7216 16.515072-41.0624 14.76608-82.126848 29.526016-123.19744 44.261376-34.709504 12.455936-50.874368 47.372288-37.947392 82.3808 39.161856 106.059776 78.444544 212.078592 117.567488 318.154752 12.972032 35.170304 25.608192 70.463488 38.387712 105.70752 0.647168 1.785856 1.183744 3.612672 2.33472 7.145472-13.45536-13.625344-25.67168-25.964544-37.851136-38.336512-84.850688-86.218752-169.689088-172.447744-254.543872-258.664448-26.599424-27.027456-26.281984-65.564672 1.019904-92.104704 73.957376-71.899136 147.984384-143.726592 222.005248-215.558144 24.834048-24.098816 60.848128-25.022464 86.372352-1.687552 10.778624 9.854976 20.512768 20.840448 31.574016 32.186368z" p-id="6326"></path><path d="M324.5568 627.775488c-11.081728-30.138368-22.14912-60.284928-33.241088-90.4192-29.861888-81.137664-59.10528-162.5088-89.878528-243.300352-13.973504-36.691968 3.360768-75.446272 41.295872-88.969216 96.937984-34.553856 193.384448-70.486016 290.084864-105.70752 31.234048-11.378688 65.763328 3.950592 78.053376 34.719744 6.023168 15.079424 10.99776 30.574592 16.738304 46.700544-2.574336 0.0512-4.624384 0.147456-6.674432 0.129024-74.620928-0.784384-149.241856-1.5872-223.862784-2.36544-28.448768-0.29696-52.625408 14.86848-62.22848 40.138752-2.811904 7.395328-4.007936 15.80032-4.124672 23.76704-1.830912 126.072832-3.364864 252.145664-4.97664 378.222592-0.03072 2.330624-0.155648 4.657152-0.233472 6.987776l-0.95232 0.096256z" p-id="6327"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        path: 'slots',
        name: 'betting_slots',
        component: `/src/ui/views/${platform}/BettingSlots/BettingSlotsView.vue`,
        meta: {
          title: { zh: '插槽', ko: '슬롯', en: 'Slot', vi: 'Máy đánh bạc', th: 'สล็อต', my: 'ဆလော့' },
          icon: '<svg t="1717054157328" class="icon" viewBox="0 0 1706 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20249" width="24" height="24"><path d="M1582.08 467.626667V155.306667c17.066667-8.533333 20.48-22.186667 20.48-37.546667 0-25.6-20.48-46.08-46.08-46.08-25.6 0-46.08 20.48-46.08 46.08 0 15.36 1.706667 30.72 20.48 37.546667v308.906666h-34.133333V186.026667H1250.986667V98.986667h-870.4v87.04H100.693333v696.32h-17.066666v69.973333h512c40.96 39.253333 117.76 64.853333 206.506666 64.853333s165.546667-25.6 206.506667-64.853333h503.466667v-69.973333h-17.066667V604.16h52.906667c39.253333 0 73.386667-32.426667 73.386666-71.68 0-29.013333-20.48-52.906667-39.253333-64.853333zM571.733333 727.04H189.44V273.066667h384v453.973333z m232.106667 220.16c-97.28 0-175.786667-18.773333-175.786667-42.666667s78.506667-42.666667 175.786667-42.666666c97.28 0 175.786667 18.773333 175.786667 42.666666s-78.506667 42.666667-175.786667 42.666667zM989.866667 727.04H607.573333V273.066667H989.866667v453.973333z m418.133333 0H1025.706667V273.066667h384v453.973333z m0 0" fill="" p-id="20250"></path><path d="M288.426667 390.826667h-39.253334v109.226666h37.546667s10.24-39.253333 35.84-35.84c25.6 1.706667 46.08 13.653333 78.506667 10.24 0 0-93.866667 52.906667-93.866667 143.36h134.826667s-10.24-128 64.853333-204.8L477.866667 389.12s-29.013333 27.306667-90.453334 3.413333c0 0-47.786667-17.066667-98.986666 10.24v-11.946666z m424.96 0h-40.96v109.226666h37.546666s10.24-39.253333 35.84-35.84c25.6 1.706667 46.08 13.653333 78.506667 10.24 0 0-93.866667 52.906667-93.866667 143.36h134.826667s-10.24-128 64.853333-204.8l-29.013333-23.893333s-29.013333 27.306667-90.453333 3.413333c0 0-47.786667-17.066667-98.986667 10.24l1.706667-11.946666z m424.96 0h-40.96v109.226666h37.546666s10.24-39.253333 35.84-35.84c25.6 1.706667 46.08 13.653333 78.506667 10.24 0 0-93.866667 52.906667-93.866667 143.36h134.826667s-10.24-128 64.853333-204.8l-29.013333-23.893333s-29.013333 27.306667-90.453333 3.413333c0 0-47.786667-17.066667-98.986667 10.24l1.706667-11.946666z m0 0M687.786667 117.76c0 61.44 49.493333 112.64 112.64 112.64 61.44 0 112.64-49.493333 112.64-112.64 0-61.44-49.493333-112.64-112.64-112.64-61.44 0-112.64 49.493333-112.64 112.64z m0 0" fill="" p-id="20251"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
    ],
  },

  {
    name: 'web',
    meta: {
      title: {
        zh: '用户网站',
        ko: '사이트설정',
        en: 'User Website',
        vi: 'Trang web người dùng',
        th: 'เว็บไซต์ของผู้ใช้งาน',
        my: 'အပိုဆောင်း လုပ်ဆောင်ချက်များ',
      },
      icon: '<svg t="1742178246304" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12679" width="48" height="48"><path d="M143.9 438.6c53.6-183 171-313.5 385.7-332.1 14.8-1.3 35.5-0.1 52.4-3.3 14.5-2.8 32.3-13.3 49-20.2 68-27.8 218.3-76.7 294.2-16.8 65.8 52.2 53.7 179 13.1 261.7 32.5 65.4 56.5 156.4 42.5 258.3-190.7 7.8-412.9 1-598.2 3.4 6.2 98.4 68.2 173.8 160.2 184.5 89.9 10.4 152-40.2 192.9-97.3h228.8C904.9 847.1 753.8 979.1 519.8 962c-53.2-3.9-94.7-19.4-140.6-37-76.7 41.8-246.3 103.9-313.8 16.8-51.3-66.2-18.3-186.5 9.8-265 56.9-159 165.3-316.5 271.3-406 0.6-2.8 3.3-3.4 3.3-6.7-83.7 42.6-140.2 113.3-205.9 174.5zM948 190.3c-3.1-114.2-150.9-103-228.8-57 87.1 34.7 150.7 93.6 202.7 164.3 11.2-35.8 27.3-65.6 26.1-107.3zM382.5 468.7h362.8c-10.5-233.3-351.4-214.4-362.8 0z m-268 409.4c18.2 103.3 163.3 73.2 228.8 26.9-86.1-48.2-139.7-129.5-183.1-221.5-20.1 49.7-57.7 126.4-45.7 194.6z m0 0" fill="#040000" p-id="12680"></path></svg>',
      needLogin: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'i18n',
        component: `/src/ui/views/${platform}/Web/I18n/WebI18nView.vue`,
        meta: {
          title: {
            zh: '国际化支持',
            ko: '다국어설정',
            en: 'Internationalization Support',
            vi: 'Hỗ trợ bản dịch',
            th: 'การสนับสนุนการแปล',
            my: 'Internationalization Support',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'rules',
        component: `/src/ui/views/${platform}/Web/Rule/WebRuleView.vue`,
        meta: {
          title: {
            zh: '网站规则',
            ko: '사이트 규정',
            en: 'Rule Description',
            vi: 'Mô tả quy tắc',
            th: 'คำอธิบายกฎบัตร',
            my: 'ကစားသမား မှတ်စုများ',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'recharge_bank_rule',
        component: `/src/ui/views/${platform}/Web/Content/index.vue`,
        meta: {
          category: 'recharge_bank_rule',
          title: {
            zh: '银行充值规则',
            ko: '계좌 입금 규정',
            en: 'Bank Recharge Rule',
            vi: 'Quy tắc nạp tiền ngân hàng',
            th: 'กฎการฝากเงินธนาคาร',
            my: 'ကစားသမား မှတ်စုများ',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'withdraw_bank_rule',
        component: `/src/ui/views/${platform}/Web/Content/index.vue`,
        meta: {
          category: 'withdraw_bank_rule',
          title: {
            zh: '银行提现规则',
            ko: '계좌 출금 규정',
            en: 'Bank Withdraw Rule',
            vi: 'Quy tắc rút tiền ngân hàng',
            th: 'กฎการถอนเงินธนาคาร',
            my: 'ဘဏ်ငွေထုတ်ယူမှုစည်းမျဉ်း',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'recharge_usdt_rule',
        component: `/src/ui/views/${platform}/Web/Content/index.vue`,
        meta: {
          category: 'recharge_usdt_rule',
          title: {
            zh: 'USDT充值规则',
            ko: 'USDT 입금 규정',
            en: 'USDT Recharge Rule',
            vi: 'Quy tắc nạp tiền USDT',
            th: 'กฎการฝากเงิน USDT',
            my: 'USDT ငွေသွင်းစည်းမျဉ်း',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'withdraw_usdt_rule',
        component: `/src/ui/views/${platform}/Web/Content/index.vue`,
        meta: {
          category: 'withdraw_usdt_rule',
          title: {
            zh: 'USDT提现规则',
            ko: 'USDT 출금 규정',
            en: 'USDT Withdraw Rule',
            vi: 'Quy tắc rút tiền USDT',
            th: 'กฎการถอนเงิน USDT',
            my: 'USDT ငွေထုတ်ယူမှုစည်းမျဉ်း',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'web_faqs',
        component: `/src/ui/views/${platform}/Web/Faq/index.vue`,
        meta: {
          title: {
            zh: '常见问题',
            ko: '자주 묻는 질문',
            en: 'Frequently Asked Questions',
            vi: 'Câu hỏi thường gặp',
            th: 'คำถามที่พบบ่อย',
            my: 'များများသော မေးခွန်းများ',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'vip_rule',
        component: `/src/ui/views/${platform}/Web/Vip/VipRuleView.vue`,
        meta: {
          category: 'vip_rule',
          title: {
            zh: 'VIP说明',
            ko: 'VIP 설명',
            en: 'VIP Description',
            vi: 'Mô tả VIP',
            th: 'คำอธิบาย VIP',
            my: 'VIP မှတ်စုများ',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'privacy_policy',
        component: `/src/ui/views/${platform}/Web/Content/index.vue`,
        meta: {
          category: 'privacy_policy',
          title: {
            zh: '隐私政策',
            ko: '개인정보 보호',
            en: 'Privacy Policy',
            vi: 'Chính sách bảo mật',
            th: 'นโยบายความเป็นส่วนตัว',
            my: 'ကိုယ်ရေးကိုယ်တာ မူဝါဒ',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'terms_of_service',
        component: `/src/ui/views/${platform}/Web/Content/index.vue`,
        meta: {
          category: 'terms_of_service',
          title: {
            zh: '服务条款',
            ko: '이용 약관',
            en: 'Terms of Service',
            vi: 'Điều khoản dịch vụ',
            th: 'ข้อกำหนดการให้บริการ',
            my: 'ဝန်ဆောင်မှု စည်းမျဉ်းများ',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'responsible_gaming',
        component: `/src/ui/views/${platform}/Web/Content/index.vue`,
        meta: {
          category: 'responsible_gaming',
          title: {
            zh: '负责任的博彩',
            ko: '책임있는 게임',
            en: 'Responsible Gaming',
            vi: 'Chơi game có trách nhiệm',
            th: 'การเล่นเกมอย่างรับผิดชอบ',
            my: 'တာဝန်ယူမှုရှိသော ဂိမ်းကစားခြင်း',
          },
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },

  {
    name: 'addon',
    meta: {
      title: {
        zh: '附加功能',
        ko: '부가기능',
        en: 'Additional Features',
        vi: 'Tính năng bổ sung',
        th: 'คุณสมบัติเพิ่มเติม',
        my: 'အပိုဆောင်း လုပ်ဆောင်ချက်များ',
      },
      icon: '<svg t="1718420728649" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15786" width="24" height="24"><path d="M573.013333 231.68v57.173333c-111.786667 8.96-175.36 80.64-175.36 198.826667V682.666667H231.68C133.973333 682.666667 85.333333 634.026667 85.333333 536.32V231.68C85.333333 133.973333 133.973333 85.333333 231.68 85.333333H426.666667c97.706667 0 146.346667 48.64 146.346666 146.346667z" fill="#292D32" p-id="15787"></path><path d="M792.32 341.333333H597.333333c-97.706667 0-146.346667 48.64-146.346666 146.346667v304.64c0 97.706667 48.64 146.346667 146.346666 146.346667h194.986667c97.706667 0 146.346667-48.64 146.346667-146.346667v-304.64C938.666667 389.973333 890.026667 341.333333 792.32 341.333333z m-18.773333 330.666667h-37.546667v37.546667c0 17.493333-14.506667 32-32 32s-32-14.506667-32-32v-37.546667h-37.546667c-17.493333 0-32-14.506667-32-32s14.506667-32 32-32h37.546667v-37.546667c0-17.493333 14.506667-32 32-32s32 14.506667 32 32v37.546667h37.546667c17.493333 0 32 14.506667 32 32s-14.506667 32-32 32z" fill="#292D32" p-id="15788"></path></svg>',
      needLogin: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'player_msg',
        component: `/src/ui/views/${platform}/PlayerMessage/PlayerMessageView.vue`,
        meta: {
          title: {
            zh: '玩家小纸条',
            ko: '쪽지발송',
            en: 'Player Notes',
            vi: 'Ghi chú người chơi',
            th: 'บันทึกย่อผู้เล่น',
            my: 'ကစားသမား မှတ်စုများ',
          },
          icon: '<svg t="1718420685184" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14785" width="24" height="24"><path d="M752.32 175.16L138.36 561.78c-3.26 2.05-3.13 6.95 0.22 8.82 0 0 248.03 72.34 247.9 73.88l372-468.31c-1.51-1.7-4-2.37-6.16-1.01zM414.92 684.86l-1.44 184.22c-0.32 7 8.43 10.11 12.39 4.41l113.68-157.33-123.43-32.94-1.2 1.64zM768.95 177.42c-0.11-0.15-0.28-0.24-0.4-0.37L413.48 659.6c0.63-0.87 308.95 82.16 311.18 82.73 3.42 1.74 7.39-0.97 7.15-4.89l38.24-557.25c-0.06-0.89-0.37-1.66-0.78-2.34l-0.32-0.43z" fill="#6B6B6B" p-id="14786"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'download_excel',
        component: `/src/ui/views/${platform}/DownloadExcel/DownloadExcelView.vue`,
        meta: {
          title: {
            zh: '下载Excel',
            ko: '엑셀 다운로드',
            en: 'Download Excel',
            vi: 'Tải xuống Excel',
            th: 'ดาวน์โหลด Excel',
            my: 'Excel ဒေါင်းလုတ်',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },

      {
        name: 'send_sms',
        component: `/src/ui/views/${platform}/__BaseAdmin/Developing/DevelopingView.vue`,
        meta: {
          title: { zh: '发送短信', ko: 'SMS문자발송', en: 'Send SMS', vi: 'Gửi SMS', th: 'ส่ง SMS', my: 'SMS ပေးပို့' },
          icon: '<svg t="1719054122032" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16974" width="24" height="24"><path d="M868.949333 580.096a301.952 301.952 0 0 0-23.850666-111.061333c-9.685333-23.082667-24.106667-43.818667-35.584-66.133334a225.066667 225.066667 0 0 1-18.176-158.805333c-59.818667 22.229333-108.288 67.413333-131.456 122.325333a199.253333 199.253333 0 0 0-14.805334 58.666667 490.325333 490.325333 0 0 1-102.528-267.52 475.733333 475.733333 0 0 1 3.072-92.16 533.76 533.76 0 0 0-136.533333 152.746667 476.714667 476.714667 0 0 0-59.733333 328.234666A313.6 313.6 0 0 1 262.314667 349.866667c-65.962667 57.344-106.112 137.386667-110.848 220.330666-4.821333 84.821333 28.202667 169.898667 90.026666 233.386667 60.757333 62.421333 147.712 102.186667 238.933334 108.928 93.44 6.912 188.501333-20.608 260.266666-75.52 68.949333-52.565333 114.602667-129.024 125.525334-210.389333 0.469333-3.797333 1.408-19.285333 2.730666-46.506667z" fill="#FF5000" p-id="16975"></path></svg>',
          hidden: true,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },

  {
    name: 'coin',
    meta: {
      title: {
        zh: '加密货币',
        ko: '암호화폐',
        en: 'Coin',
        vi: 'Tiền điện tử',
        th: 'การตั้งค่าสกุลเงิน',
        my: 'ငွေကိုင် ပြင်ဆင်မှု',
      },
      icon: '<svg t="1721734919629" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4869" width="32" height="32"><path d="M985.6 544.459L529.525 721.002h-21.758L44.223 544.459A36.819 36.819 0 0 0 0.066 581.235v375.143a34.728 34.728 0 0 0 36.777 36.776H985.6a34.728 34.728 0 0 0 36.776-36.776V581.235a29.48 29.48 0 0 0-36.776-36.776zM831.287 0.11h-632.62a84.986 84.986 0 0 0-88.271 88.357v411.919l404.581 154.486 404.581-154.486V88.467A84.986 84.986 0 0 0 831.286 0.198zM721.085 389.973H309.038a30.163 30.163 0 1 1 0-58.833h419.3a33.662 33.662 0 0 1 36.776 29.438c0 14.719-22.057 29.438-44.157 29.438z m0-191.262H309.038a33.662 33.662 0 0 1-36.776-29.438 34.728 34.728 0 0 1 36.776-36.776h419.3a33.662 33.662 0 0 1 36.776 29.438 46.632 46.632 0 0 1-44.157 36.776z" fill="#00AAA6" p-id="4870"></path></svg>',
      needLogin: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'coin_config',
        component: `/src/ui/views/${platform}/CoinConfig/CoinConfigView.vue`,
        meta: {
          title: {
            zh: '基础配置',
            ko: '기본 설정',
            en: 'Basic Config',
            vi: 'Cấu hình cơ bản',
            th: 'การตั้งค่าพื้นฐาน',
            my: 'အရေအတွက် ပြင်ဆင်မှု',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'coin_wallets',
        component: `/src/ui/views/${platform}/CoinWallets/CoinWalletsView.vue`,
        meta: {
          title: {
            zh: '钱包配置',
            ko: '지갑 설정',
            en: 'Wallet Config',
            vi: 'Cấu hình ví',
            th: 'การตั้งค่ากระเป๋าเงิน',
            my: 'ငွေကိုင် ပြင်ဆင်မှု',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'coin_transcations',
        component: `/src/ui/views/${platform}/CoinTranscations/CoinTranscationsView.vue`,
        meta: {
          title: {
            zh: '订单列表',
            ko: '주문 목록',
            en: 'Order List',
            vi: 'Danh sách đơn hàng',
            th: 'รายการคำสั่งซื้อ',
            my: 'ငွေကိုင်စာရင်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },

  {
    name: 'shooter',
    meta: {
      title: {
        zh: '自动对账',
        ko: '자동입금',
        en: 'Automatic Reconciliation',
        vi: 'Đối Soát Tự Động',
        th: 'การกระทบยอดอัตโนมัติ',
        my: 'အလိုအလျောက် ငွေစာရင်းရှင်း',
      },
      icon: '<svg t="1721734919629" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4869" width="32" height="32"><path d="M985.6 544.459L529.525 721.002h-21.758L44.223 544.459A36.819 36.819 0 0 0 0.066 581.235v375.143a34.728 34.728 0 0 0 36.777 36.776H985.6a34.728 34.728 0 0 0 36.776-36.776V581.235a29.48 29.48 0 0 0-36.776-36.776zM831.287 0.11h-632.62a84.986 84.986 0 0 0-88.271 88.357v411.919l404.581 154.486 404.581-154.486V88.467A84.986 84.986 0 0 0 831.286 0.198zM721.085 389.973H309.038a30.163 30.163 0 1 1 0-58.833h419.3a33.662 33.662 0 0 1 36.776 29.438c0 14.719-22.057 29.438-44.157 29.438z m0-191.262H309.038a33.662 33.662 0 0 1-36.776-29.438 34.728 34.728 0 0 1 36.776-36.776h419.3a33.662 33.662 0 0 1 36.776 29.438 46.632 46.632 0 0 1-44.157 36.776z" fill="#00AAA6" p-id="4870"></path></svg>',
      needLogin: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'shooter_sms',
        component: `/src/ui/views/${platform}/ShooterSms/ShooterSmsView.vue`,
        meta: {
          title: {
            zh: '短信列表',
            ko: '문자 리스트',
            en: 'SMS List',
            vi: 'Danh Sách Thiết Bị',
            th: 'รายการ SMS',
            my: 'SMS စာရင်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },

      {
        name: 'shooter_pushbullet',
        component: `/src/ui/views/${platform}/ShooterPushBullet/ShooterPushBulletView.vue`,
        meta: {
          title: {
            zh: 'PushBullet',
            ko: 'PushBullet',
            en: 'PushBullet',
            vi: 'PushBullet',
            th: 'PushBullet',
            my: 'PushBullet',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      // {
      //   name: 'devices',
      //   component: `/src/ui/views/${platform}/ShooterDevices/ShooterDevicesView.vue`,
      //   meta: {
      //     title: {
      //       zh: '设备列表',
      //       ko: '핸드폰 등록',
      //       en: 'Device List',
      //       vi: 'Danh Sách Thiết Bị',
      //       th: 'รายการอุปกรณ์',
      //       my: 'စက်ပစ္စည်း စာရင်း',
      //     },
      //     icon: '',
      //     hidden: false,
      //     cache: true,
      //     needLogin: true,
      //     public: {
      //       desktop: true,
      //       mobile: true,
      //     },
      //   },
      // },
      {
        name: 'shooter_phone',
        component: `/src/ui/views/${platform}/ShooterPhone/ShooterPhoneView.vue`,
        meta: {
          title: {
            zh: '手机号白名单',
            ko: '화이트 번호',
            en: 'Phone Number Whitelist',
            vi: 'Danh Sách Trắng Số Điện Thoại',
            th: 'บัญชีขาวหมายเลขโทรศัพท์',
            my: 'ဖုန်းနံပါတ် အဖြူစာရင်း',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'templates',
        component: `/src/ui/views/${platform}/ShooterTemplate/ShooterTemplateView.vue`,
        meta: {
          title: {
            zh: '短信模板',
            ko: '문자 템플릿',
            en: 'SMS Template',
            vi: 'Mẫu Tin Nhắn SMS',
            th: 'แม่แบบ SMS',
            my: 'SMS ပုံစံ',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },

  {
    name: 'base',
    meta: {
      title: {
        zh: '基础配置',
        ko: '기본설정',
        en: 'Basic Configuration',
        vi: 'Cấu hình cơ bản',
        th: 'การตั้งค่าพื้นฐาน',
        my: 'အခြေခံ ကွန်ဖစ်',
      },
      icon: '<svg t="1704615931987" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18615" width="32" height="32"><path d="M947.2 422.4H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V473.6c0-38.4-12.8-51.2-51.2-51.2z m0-339.2H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V134.4c0-38.4-12.8-51.2-51.2-51.2zM217.6 422.4H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V473.6c-6.4-38.4-19.2-51.2-57.6-51.2z m0-339.2H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V134.4c-6.4-38.4-19.2-51.2-57.6-51.2zM947.2 768H416c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c0-32-12.8-44.8-51.2-44.8zM217.6 768H76.8c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c-6.4-32-19.2-44.8-57.6-44.8z" fill="#040000" p-id="18616"></path></svg>',
      hidden: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    redirect: '/base/player_level',
    children: [
      {
        name: 'player_level',
        component: `/src/ui/views/${platform}/PlayerLevel/PlayerLevelView.vue`,
        meta: {
          title: {
            zh: '玩家等级',
            ko: '회원등급',
            en: 'Player Level',
            vi: 'Cấp độ người chơi',
            th: 'ระดับผู้เล่น',
            my: 'ကစားသမားအဆင့်',
          },
          icon: '',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },

      {
        name: 'referrer',
        component: `/src/ui/views/${platform}/Referrer/ReferrerView.vue`,
        meta: {
          title: {
            zh: '好友邀请',
            ko: '친구초대',
            en: 'Friend Invitation',
            vi: 'Mời bạn bè',
            th: 'เชิญเพื่อน',
            my: 'မိတ်ဆွေ ဖိတ်ကြားခြင်း',
          },
          icon: '',
          hidden: true,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'banks',
        component: `/src/ui/views/${platform}/Bank/BankView.vue`,
        meta: {
          title: {
            zh: '银行卡管理',
            ko: '은행설정',
            en: 'Bank Card Management',
            vi: 'Quản lý thẻ ngân hàng',
            th: 'การจัดการบัตรธนาคาร',
            my: 'ဘဏ်ကတ် စီမံခန့်ခွဲမှု',
          },
          icon: '<svg t="1717987151957" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6085" width="24" height="24"><path d="M1024 254.144v56.384H0v-56.384c0-42.24 34.56-76.8 76.8-76.8h870.4c42.24 0 76.8 34.56 76.8 76.8zM0 378.432v391.488c0 42.24 34.56 76.8 76.8 76.8h870.4c42.24 0 76.8-34.56 76.8-76.8V378.432H0z m926.08 363.52c-6.144 6.144-14.592 9.984-23.936 9.984h-196.48c-18.624 0-33.92-15.296-33.92-33.92 0-9.344 3.84-17.856 9.984-24 6.144-6.144 14.592-9.984 23.936-9.984h196.48c18.688 0 33.92 15.296 33.92 33.984 0 9.344-3.84 17.792-9.984 23.936z" fill="#666666" p-id="6086"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'notice',
        component: `/src/ui/views/${platform}/Settings/PopNoticeView.vue`,
        meta: {
          title: {
            zh: '弹窗公告',
            ko: '팝업공지',
            en: 'Popup Announcement',
            vi: 'Thông báo bật lên',
            th: 'ประกาศป๊อปอัป',
            my: 'ပေါ့ပ်အပ် ကြေငြာချက်',
          },
          icon: '<svg t="1708419241041" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17733" width="200" height="200"><path d="M640 1024c-8.533333 0-14.933333-2.133333-21.333333-8.533333L307.2 736H128c-51.2 0-128-34.133333-128-128v-192c0-51.2 34.133333-128 128-128h179.2L618.666667 8.533333c8.533333-8.533333 23.466667-10.666667 34.133333-6.4s19.2 17.066667 19.2 29.866667v960c0 12.8-6.4 23.466667-19.2 29.866667-4.266667 2.133333-8.533333 2.133333-12.8 2.133333zM800 320c-8.533333 0-17.066667-2.133333-23.466667-8.533333-12.8-12.8-12.8-32 0-44.8l128-128c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8l-128 128c-4.266667 6.4-12.8 8.533333-21.333333 8.533333zM992 544h-192c-17.066667 0-32-14.933333-32-32s14.933333-32 32-32h192c17.066667 0 32 14.933333 32 32s-14.933333 32-32 32zM928 896c-8.533333 0-17.066667-2.133333-23.466667-8.533333l-128-128c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l128 128c12.8 12.8 12.8 32 0 44.8-4.266667 6.4-12.8 8.533333-21.333333 8.533333z" p-id="17734"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'scroll',
        component: `/src/ui/views/${platform}/Settings/ScrollNoticeView.vue`,
        meta: {
          title: {
            zh: '滚动公告',
            ko: '한줄공지',
            en: 'Scrolling Announcement',
            vi: 'Thông báo cuộn',
            th: 'ประกาศเลื่อน',
            my: 'လှိမ့်ကြေငြာချက်',
          },
          icon: '<svg t="1708419241041" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17733" width="200" height="200"><path d="M640 1024c-8.533333 0-14.933333-2.133333-21.333333-8.533333L307.2 736H128c-51.2 0-128-34.133333-128-128v-192c0-51.2 34.133333-128 128-128h179.2L618.666667 8.533333c8.533333-8.533333 23.466667-10.666667 34.133333-6.4s19.2 17.066667 19.2 29.866667v960c0 12.8-6.4 23.466667-19.2 29.866667-4.266667 2.133333-8.533333 2.133333-12.8 2.133333zM800 320c-8.533333 0-17.066667-2.133333-23.466667-8.533333-12.8-12.8-12.8-32 0-44.8l128-128c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8l-128 128c-4.266667 6.4-12.8 8.533333-21.333333 8.533333zM992 544h-192c-17.066667 0-32-14.933333-32-32s14.933333-32 32-32h192c17.066667 0 32 14.933333 32 32s-14.933333 32-32 32zM928 896c-8.533333 0-17.066667-2.133333-23.466667-8.533333l-128-128c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l128 128c12.8 12.8 12.8 32 0 44.8-4.266667 6.4-12.8 8.533333-21.333333 8.533333z" p-id="17734"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'player_tags',
        component: `/src/ui/views/${platform}/PlayerTag/PlayerTagView.vue`,
        meta: {
          title: {
            zh: '玩家标签',
            ko: '태그설정',
            en: 'Player Tag',
            vi: 'Thẻ người chơi',
            th: 'แท็กผู้เล่น',
            my: 'ကစားသမား တံဆိပ်',
          },
          icon: '<svg t="1718248225079" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6055" width="24" height="24"><path d="M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-0.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-0.2-4.7 0.6-6.3 2.3L137.7 444.8c-3.1 3.1-3.1 8.2 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0z m122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9z" p-id="6056"></path><path d="M889.7 539.8l-39.6-39.5c-3.1-3.1-8.2-3.1-11.3 0l-362 361.3-237.6-237c-3.1-3.1-8.2-3.1-11.3 0l-39.6 39.5c-3.1 3.1-3.1 8.2 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z" p-id="6057"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      // 游戏供应商
      {
        name: 'game_provider',
        component: `/src/ui/views/${platform}/GameProvider/GameProviderView.vue`,
        meta: {
          title: {
            zh: '游戏供应商',
            ko: '게임사설정',
            en: 'Game Provider',
            vi: 'Nhà cung cấp trò chơi',
            th: 'ผู้ให้บริการเกม',
            my: 'ဂိမ်းပေးသွင်းသူ',
          },
          icon: '<svg t="1719557213279" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4076" width="24" height="24"><path d="M512 0L68.608 256v512l443.392 256 443.392-256V256z m291.84 402.944l-240.64 138.752V819.2a51.2 51.2 0 0 1-102.4 0v-277.504L222.208 402.944a51.2 51.2 0 0 1 51.2-89.088l240.64 139.264 240.64-139.264a51.2 51.2 0 0 1 51.2 89.088z" p-id="4077"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'sys_msg',
        component: `/src/ui/views/${platform}/SysMessage/SysMessageView.vue`,
        meta: {
          title: {
            zh: '系统消息',
            ko: '시스템메세지',
            en: 'System Message',
            vi: 'Thông báo hệ thống',
            th: 'ข้อความระบบ',
            my: 'စနစ် သတင်းစကား',
          },
          icon: '<svg t="1718265903295" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10389" width="24" height="24"><path d="M980.64186 313.257045c-25.680155-61.285204-62.653451-116.290768-109.663961-163.536127C823.957178 102.598089 769.063933 65.502264 707.778728 39.83232 645.125277 13.468041 578.704042 0.112319 510.118118 0.112319h-2.287219c-69.04541 0.336956-135.803602 14.039846-198.68169 40.965718-60.7134 26.027322-115.147159 62.990407-161.708394 110.133658-46.561235 47.13304-83.075045 101.903755-108.418244 162.964322C12.903352 377.391062-0.329841 444.61895 0.007115 513.766468c0.347167 79.205153 19.288196 157.828291 54.658397 228.129629v173.461022c0 28.988453 23.505255 52.493708 52.381389 52.493708h173.236384c70.178809 35.492731 148.58752 54.433759 227.670144 54.780926h2.399537c68.238757 0 134.323036-13.243404 196.62932-39.148196 60.938037-25.445306 115.718964-61.959117 162.617155-108.642881 47.020721-46.673554 83.994017-101.229843 109.89881-162.045351 26.813553-63.000618 40.506232-129.983447 40.853399-199.141176 0.224638-69.494685-13.233193-136.947211-39.70979-200.397104zM282.335656 566.147857c-30.132062 0-54.668608-24.536545-54.668608-54.780926 0-30.244381 24.536545-54.770716 54.668608-54.770716 30.121852 0 54.658397 24.536545 54.658397 54.770716 0.010211 30.254592-24.414016 54.780927-54.658397 54.780926z m227.782462 0c-30.132062 0-54.668608-24.536545-54.668608-54.780926 0-30.244381 24.536545-54.770716 54.668608-54.770716 30.121852 0 54.668608 24.536545 54.668608 54.770716 0 30.254592-24.536545 54.780927-54.668608 54.780926z m227.792673 0c-30.132062 0-54.658397-24.536545-54.658397-54.780926 0-30.244381 24.536545-54.770716 54.658397-54.770716 30.132062 0 54.658397 24.536545 54.658397 54.770716 0 30.254592-24.536545 54.780927-54.658397 54.780926z m0 0" fill="#2C2C2C" p-id="10390"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'maintenance',
        component: `/src/ui/views/${platform}/Maintenance/MaintenanceView.vue`,
        meta: {
          title: {
            zh: '网站维护',
            ko: '사이트 점검',
            en: 'Website Maintenance',
            vi: 'Bảo trì trang web',
            th: 'การบำรุงรักษาเว็บไซต์',
            my: 'ဝဘ်ဆိုဒ် ပြုပြင်ထိန်းသိမ်းမှု',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'cloudflare_whitelist',
        component: `/src/ui/views/${platform}/CloudflareWhitelist/CloudflareWhitelistView.vue`,
        meta: {
          title: {
            zh: '管理员IP设置',
            ko: '관리자IP설정',
            en: 'Admin IP Settings',
            vi: 'Admin IP Settings',
            th: 'Admin IP Settings',
            my: 'Admin IP Settings',
          },
          icon: '<svg t="1719036283095" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5001" width="24" height="24"><path d="M512 85.333333C276.48 85.333333 85.333333 276.48 85.333333 512s191.146667 426.666667 426.666667 426.666667 426.666667-191.146667 426.666667-426.666667S747.52 85.333333 512 85.333333z m-42.666667 640V298.666667l256 213.333333-256 213.333333z" p-id="5002"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: false,
          },
        },
      },
      {
        name: 'web_settings',
        component: `/src/ui/views/${platform}/WebSettingsConfig/WebSettingsConfigView.vue`,
        meta: {
          title: {
            zh: '网站基础设置',
            ko: '사이트 설정',
            en: 'Website Basic Settings',
            vi: 'Cài đặt cơ bản trang web',
            th: 'การตั้งค่าพื้นฐานของเว็บไซต์',
            my: 'ဝဘ်ဆိုဒ် အခမဲ့ ပြင်ဆင်မှု',
          },
          icon: '',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },

  {
    name: 'team',
    meta: {
      title: {
        zh: '团队管理',
        ko: '권한관리',
        en: 'Team Management',
        vi: 'Quản lý đội nhóm',
        th: 'การจัดการทีม',
        my: 'အသင်းစီမံခန့်ခွဲမှု',
      },
      icon: '<svg t="1704615311299" class="icon" viewBox="0 0 1066 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2263" width="32" height="32"><path d="M754.785652 1024v-43.663875a109.149023 109.149023 0 0 1 109.127692-109.170354h87.30642a109.149023 109.149023 0 0 1 109.127693 109.170354v43.663875H754.785652z m152.791568-185.576803a98.249052 98.249052 0 1 1 0-196.498104 98.249052 98.249052 0 0 1 0 196.498104z m-202.342708-43.663875a37.755281 37.755281 0 0 1-19.069616-5.140691l-152.919552-88.308961-152.940882 88.308961a38.181894 38.181894 0 0 1-38.181894-66.167729l152.919552-88.308961v-176.639254a38.181894 38.181894 0 1 1 76.385118 0v176.639254l152.940883 88.308961a38.245886 38.245886 0 0 1-19.133609 71.30842zM372.817398 338.432363a109.149023 109.149023 0 0 1 109.127692-109.191685h87.30642a109.149023 109.149023 0 0 1 109.127693 109.191685v43.642544H372.817398v-43.642544z m152.791568-141.934259a98.249052 98.249052 0 1 1 0-196.498104 98.249052 98.249052 0 0 1 0 196.498104zM6.121901 980.336125a109.170354 109.170354 0 0 1 109.127693-109.170354h87.30642a109.149023 109.149023 0 0 1 109.127692 109.170354v43.663875H6.121901v-43.663875z m152.791568-141.912928a98.227722 98.227722 0 0 1-98.227721-98.249052 98.249052 98.249052 0 1 1 98.227721 98.249052z" fill="#E65256" p-id="2264"></path></svg>',
      needLogin: true,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'accounts',
        component: `/src/ui/views/${platform}/__BaseAdmin/User/UserListView.vue`,
        meta: {
          title: { zh: '账号', ko: '계정 리스트', en: 'Account', vi: 'Tài khoản', th: 'บัญชี', my: 'အကောင့်' },
          icon: '<svg t="1704615858284" class="icon" viewBox="0 0 1047 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14297" width="32" height="32"><path d="M280.409302 704.726326H40.078884A28.600558 28.600558 0 0 0 11.430698 733.350698v240.330418c0 15.812465 12.811907 28.624372 28.624372 28.624372h240.330418c15.812465 0 28.624372-12.811907 28.624372-28.624372V733.350698c0-15.812465-12.811907-28.624372-28.624372-28.624372z" fill="#000000" p-id="14298"></path><path d="M646.644093 704.726326h-97.28v-171.650977h320.440558v171.650977h45.770419v-177.39014c0-22.123163-17.931907-40.05507-40.05507-40.05507H549.387907v-171.650976h97.28c15.788651 0 28.600558-12.811907 28.600558-28.624373V46.675349c0-15.812465-12.811907-28.624372-28.600558-28.624372H406.313674c-15.812465 0-28.624372 12.811907-28.624372 28.624372v240.330418c0 15.812465 12.811907 28.624372 28.624372 28.624373h97.28v171.650976H177.413953c-22.123163 0-40.05507 17.931907-40.055069 40.05507v177.413954H183.129302v-171.698605h320.440558v171.698605h-97.256186c-15.812465 0-28.624372 12.788093-28.624372 28.576744v240.354232c0 15.812465 12.811907 28.624372 28.624372 28.624372h240.330419c15.788651 0 28.600558-12.811907 28.600558-28.624372V733.350698c0-15.812465-12.811907-28.624372-28.600558-28.624372z" fill="#000000" p-id="14299"></path><path d="M772.524651 704.726326h240.354233c19.051163 0 28.600558 9.525581 28.600558 28.624372v240.330418c0 19.074977-9.525581 28.624372-28.600558 28.624372H772.524651c-19.051163 0-28.600558-9.525581-28.600558-28.624372V733.350698c0-19.074977 9.525581-28.624372 28.600558-28.624372z" fill="#000000" p-id="14300"></path></svg>',
          hidden: false,
          cache: true,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'roles',
        component: `/src/ui/views/${platform}/__BaseAdmin/Role/index.vue`,
        meta: {
          title: {
            zh: '角色管理',
            ko: '팀 권한관리',
            en: 'Role Management',
            vi: 'Quản lý vai trò',
            th: 'การจัดการบทบาท',
            my: 'အခန်းကဏ္ဍ စီမံခန့်ခွဲမှု',
          },
          icon: '<svg t="1704615858284" class="icon" viewBox="0 0 1047 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14297" width="32" height="32"><path d="M280.409302 704.726326H40.078884A28.600558 28.600558 0 0 0 11.430698 733.350698v240.330418c0 15.812465 12.811907 28.624372 28.624372 28.624372h240.330418c15.812465 0 28.624372-12.811907 28.624372-28.624372V733.350698c0-15.812465-12.811907-28.624372-28.624372-28.624372z" fill="#000000" p-id="14298"></path><path d="M646.644093 704.726326h-97.28v-171.650977h320.440558v171.650977h45.770419v-177.39014c0-22.123163-17.931907-40.05507-40.05507-40.05507H549.387907v-171.650976h97.28c15.788651 0 28.600558-12.811907 28.600558-28.624373V46.675349c0-15.812465-12.811907-28.624372-28.600558-28.624372H406.313674c-15.812465 0-28.624372 12.811907-28.624372 28.624372v240.330418c0 15.812465 12.811907 28.624372 28.624372 28.624373h97.28v171.650976H177.413953c-22.123163 0-40.05507 17.931907-40.055069 40.05507v177.413954H183.129302v-171.698605h320.440558v171.698605h-97.256186c-15.812465 0-28.624372 12.788093-28.624372 28.576744v240.354232c0 15.812465 12.811907 28.624372 28.624372 28.624372h240.330419c15.788651 0 28.600558-12.811907 28.600558-28.624372V733.350698c0-15.812465-12.811907-28.624372-28.600558-28.624372z" fill="#000000" p-id="14299"></path><path d="M772.524651 704.726326h240.354233c19.051163 0 28.600558 9.525581 28.600558 28.624372v240.330418c0 19.074977-9.525581 28.624372-28.600558 28.624372H772.524651c-19.051163 0-28.600558-9.525581-28.600558-28.624372V733.350698c0-19.074977 9.525581-28.624372 28.600558-28.624372z" fill="#000000" p-id="14300"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'login_records',
        component: `/src/ui/views/${platform}/__BaseAdmin/UserLoginRecord/UserLoginRecordView.vue`,
        meta: {
          title: {
            zh: '运营登录记录',
            ko: '관리자 로그인기록',
            en: 'Operational Login Record',
            vi: 'Ghi chép đăng nhập vận hành',
            th: 'บันทึกการเข้าสู่ระบบการดำเนินการ',
            my: 'လည်ပတ်မှု လော့ဂ်အင် မှတ်တမ်း',
          },
          icon: '<svg t="1704615931987" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18615" width="32" height="32"><path d="M947.2 422.4H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V473.6c0-38.4-12.8-51.2-51.2-51.2z m0-339.2H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V134.4c0-38.4-12.8-51.2-51.2-51.2zM217.6 422.4H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V473.6c-6.4-38.4-19.2-51.2-57.6-51.2z m0-339.2H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V134.4c-6.4-38.4-19.2-51.2-57.6-51.2zM947.2 768H416c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c0-32-12.8-44.8-51.2-44.8zM217.6 768H76.8c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c-6.4-32-19.2-44.8-57.6-44.8z" fill="#040000" p-id="18616"></path></svg>',
          hidden: false,
          cache: false,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'action_logs',
        component: `/src/ui/views/${platform}/AdminActionLog/AdminActionLogView.vue`,
        meta: {
          title: {
            zh: '运营操作记录',
            ko: '관리자 처리로그',
            en: 'Operational Operation Record',
            vi: 'Ghi chép thao tác vận hành',
            th: 'บันทึกการดำเนินการ',
            my: 'လည်ပတ်မှု လုပ်ဆောင်မှုမှတ်တမ်း',
          },
          icon: '<svg t="1704615931987" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18615" width="32" height="32"><path d="M947.2 422.4H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V473.6c0-38.4-12.8-51.2-51.2-51.2z m0-339.2H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V134.4c0-38.4-12.8-51.2-51.2-51.2zM217.6 422.4H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V473.6c-6.4-38.4-19.2-51.2-57.6-51.2z m0-339.2H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V134.4c-6.4-38.4-19.2-51.2-57.6-51.2zM947.2 768H416c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c0-32-12.8-44.8-51.2-44.8zM217.6 768H76.8c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c-6.4-32-19.2-44.8-57.6-44.8z" fill="#040000" p-id="18616"></path></svg>',
          hidden: false,
          cache: false,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },

      {
        name: 'sys_config',
        component: `/src/ui/views/${platform}/SysConfig/SysConfigView.vue`,
        meta: {
          title: {
            zh: '服务器配置',
            ko: '服务器配置',
            en: '服务器配置',
            vi: '服务器配置',
            th: '服务器配置',
            my: '服务器配置',
          },
          icon: '',
          hidden: false,
          cache: false,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'menus',
        component: `/src/ui/views/${platform}/__BaseAdmin/Menus/MenusView.vue`,
        meta: {
          title: {
            zh: '菜单管理',
            ko: '메뉴관리',
            en: 'Menu Management',
            vi: 'Quản lý menu',
            th: 'การจัดการเมนู',
            my: 'မီနူးစီမံခန့်ခွဲမှု',
          },
          icon: '<svg t="1704615931987" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18615" width="32" height="32"><path d="M947.2 422.4H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V473.6c0-38.4-12.8-51.2-51.2-51.2z m0-339.2H416c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2V134.4c0-38.4-12.8-51.2-51.2-51.2zM217.6 422.4H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V473.6c-6.4-38.4-19.2-51.2-57.6-51.2z m0-339.2H76.8c-38.4 0-51.2 12.8-51.2 51.2v147.2c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2V134.4c-6.4-38.4-19.2-51.2-57.6-51.2zM947.2 768H416c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h531.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c0-32-12.8-44.8-51.2-44.8zM217.6 768H76.8c-38.4 0-51.2 12.8-51.2 51.2V960c0 38.4 12.8 51.2 51.2 51.2h147.2c38.4 0 51.2-12.8 51.2-51.2v-147.2c-6.4-32-19.2-44.8-57.6-44.8z" fill="#040000" p-id="18616"></path></svg>',
          hidden: false,
          cache: false,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  },
]

// 只有本地调试运行的情况下，显示开发
if (process.env.NODE_ENV === 'development') {
  asyncRoutes.push({
    name: 'develop',
    meta: {
      title: {
        zh: '开发工具',
        ko: '开发工具',
        en: '开发工具',
        vi: '开发工具',
        th: '开发工具',
        my: '开发工具',
      },
      icon: '<svg t="1704705481421" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="35094" width="32" height="32"><path d="M891.23498667 161.10478222H133.34755555c-20.97152 0-37.86524445 16.89372445-37.86524444 37.86524444v528.94833778c0 20.97152 16.89372445 37.86524445 37.86524444 37.86524444h292.43619556v125.82912H284.22599111c-16.31118222 0-29.70965333 13.39847111-29.70965333 29.70965334s13.39847111 29.70965333 29.70965333 29.70965333h456.13056c16.31118222 0 29.70965333-13.39847111 29.70965334-29.70965333s-13.39847111-29.70965333-29.70965334-29.70965334H599.38133333v-125.82912h292.43619556c20.97152 0 37.86524445-16.89372445 37.86524444-37.86524444V198.97002666c-0.58254222-20.97152-17.47626667-37.86524445-38.44778666-37.86524444z m-538.26901334 386.80803556c11.65084445 11.65084445 11.65084445 30.29219555 0 41.94304-5.82542222 5.82542222-13.39847111 8.73813333-20.97152 8.73813333s-15.14609778-2.91271111-20.97152-8.73813333L205.00024889 483.83317333c-11.65084445-11.65084445-11.65084445-30.29219555 0-41.94304l106.60522666-106.60522667c11.65084445-11.65084445 30.29219555-11.65084445 41.94304 0s11.65084445 30.29219555 0 41.94304L267.91480889 462.86165333l85.05116444 85.05116445z m186.41351112 343.6999111h-54.17642667v-125.82912h54.17642667v125.82912zM613.94488889 345.77066666l-149.71335111 261.56145778c-5.24288 9.32067555-15.72864 15.14609778-25.63185778 15.14609778-5.24288 0-9.90321778-1.16508445-14.56355555-4.07779556-13.98101333-8.15559111-19.22389333-26.2144-11.06830223-40.77795555l149.71335111-261.56145778c8.15559111-13.98101333 26.2144-19.22389333 40.77795556-11.06830222 13.98101333 8.73813333 18.64135111 26.79694222 10.48576 40.77795555z m205.05486222 138.06250667l-106.02268444 106.02268445c-5.82542222 5.82542222-13.39847111 8.73813333-20.97152 8.73813333s-15.14609778-2.91271111-20.97152-8.73813333c-11.65084445-11.65084445-11.65084445-30.29219555 0-41.94304l85.05116444-85.05116445-85.05116444-85.05116445c-11.65084445-11.65084445-11.65084445-30.29219555 0-41.94304s30.29219555-11.65084445 41.94304 0l106.60522666 106.60522667c5.82542222 5.82542222 8.73813333 13.39847111 8.73813334 20.97152-0.58254222 6.99050667-3.49525333 14.56355555-9.32067556 20.38897778z" fill="#2c2c2c" p-id="35095"></path></svg>',
      needLogin: false,
      public: {
        desktop: true,
        mobile: true,
      },
    },
    children: [
      {
        name: 'gen-code',
        component: `/src/ui/views/${platform}/__BaseAdmin/Develop/GenTableView.vue`,
        meta: {
          title: {
            zh: '生成表格',
            ko: '生成表格',
            en: '生成表格',
            vi: '生成表格',
            th: '生成表格',
            my: '生成表格',
          },
          icon: '<svg t="1704705765062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="42595" width="32" height="32"><path d="M63.9 419.6h250.2v203.3H63.9V419.6z m318.4 271.5h259.3v223.8H382.3V691.1z m0-271.5h259.3v203.3H382.3V419.6z m341.3 271.5h236.5v223.8H709.9V704.8c0-7.6 6.1-13.7 13.7-13.7z m-659.7 0h250.2v223.8H63.9V691.1z m0-582h896.2v242.3H63.9V109.1z m659.7 310.5h236.5v203.3H709.9V433.3c0-7.6 6.1-13.7 13.7-13.7z" p-id="42596"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'genCreateData',
        component: `/src/ui/views/${platform}/__BaseAdmin/Develop/GenCreateData.vue`,
        meta: {
          title: {
            zh: '对话框 - 创建数据',
            ko: '对话框 - 创建数据',
            en: '对话框 - 创建数据',
            vi: '对话框 - 创建数据',
            th: '对话框 - 创建数据',
            my: '对话框 - 创建数据',
          },
          icon: '<svg t="1707386107586" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7141" width="200" height="200"><path d="M512 48.761905a65.015873 65.015873 0 0 1 65.015873 65.015873v333.206349H910.222222a65.015873 65.015873 0 1 1 0 130.031746H576.999619L577.015873 910.222222a65.015873 65.015873 0 1 1-130.031746 0l-0.016254-333.206349H113.777778a65.015873 65.015873 0 1 1 0-130.031746h333.206349V113.777778a65.015873 65.015873 0 0 1 65.015873-65.015873z" fill="#000000" p-id="7142"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'genEditData',
        component: `/src/ui/views/${platform}/__BaseAdmin/Develop/GenEditData.vue`,
        meta: {
          title: {
            zh: '对话框 - 修改数据',
            ko: '对话框 - 修改数据',
            en: '对话框 - 修改数据',
            vi: '对话框 - 修改数据',
            th: '对话框 - 修改数据',
            my: '对话框 - 修改数据',
          },
          icon: '<svg t="1707386050551" class="icon" viewBox="0 0 1291 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5124" width="200" height="200"><path d="M541.077692 773.854309c-14.577616 14.577616-34.272906 22.79691-54.58852 23.572315l-203.931547 3.101621c-23.572316-1.860972-41.871876-20.935938-44.508254-44.508254l3.101621-203.931546c0-20.315614 8.839618-40.010904 23.572316-54.588521L645.29214 116.931092l276.354384 276.354384-380.568832 380.568833z m0 0M955.76435 359.01257L679.565046 82.658186l52.107224-52.107224c41.251552-41.251552 108.556717-41.251552 149.96335 0l127.011359 127.011358c41.251552 41.251552 41.251552 108.556717 0 149.96335l-52.882629 51.4869z m0 0M1006.010601 1024h-688.559745c-43.88793 0-79.401484-35.513554-79.401485-79.401484 0-43.88793 35.513554-79.401484 79.401485-79.401484h687.939421c43.88793 0 79.401484 35.513554 79.401484 79.401484 0 43.88793-34.89323 79.401484-78.78116 79.401484z m0 0" p-id="5125"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
      {
        name: 'genDeleteData',
        component: `/src/ui/views/${platform}/__BaseAdmin/Develop/GenDeleteData.vue`,
        meta: {
          title: {
            zh: '对话框 - 删除按钮事件',
            ko: '对话框 - 删除按钮事件',
            en: '对话框 - 删除按钮事件',
            vi: '对话框 - 删除按钮事件',
            th: '对话框 - 删除按钮事件',
            my: '对话框 - 删除按钮事件',
          },
          icon: '<svg t="1707386050551" class="icon" viewBox="0 0 1291 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5124" width="200" height="200"><path d="M541.077692 773.854309c-14.577616 14.577616-34.272906 22.79691-54.58852 23.572315l-203.931547 3.101621c-23.572316-1.860972-41.871876-20.935938-44.508254-44.508254l3.101621-203.931546c0-20.315614 8.839618-40.010904 23.572316-54.588521L645.29214 116.931092l276.354384 276.354384-380.568832 380.568833z m0 0M955.76435 359.01257L679.565046 82.658186l52.107224-52.107224c41.251552-41.251552 108.556717-41.251552 149.96335 0l127.011359 127.011358c41.251552 41.251552 41.251552 108.556717 0 149.96335l-52.882629 51.4869z m0 0M1006.010601 1024h-688.559745c-43.88793 0-79.401484-35.513554-79.401485-79.401484 0-43.88793 35.513554-79.401484 79.401485-79.401484h687.939421c43.88793 0 79.401484 35.513554 79.401484 79.401484 0 43.88793-34.89323 79.401484-78.78116 79.401484z m0 0" p-id="5125"></path></svg>',
          hidden: false,
          cache: true,
          needLogin: false,
          public: {
            desktop: true,
            mobile: true,
          },
        },
      },
    ],
  })
}
